// src/locales/en.ts
// Auto-generated — do not edit manually (see scripts/i18n-*.mts)

const locale = {
  statusTranslations: {
    Submitted: "Submitted",
    Interviewing: "Interviewing",
    "Offer Made": "Offer Made",
    "Declined Offer": "Declined Offer",
    "Rejected by Recruiter": "Rejected by Recruiter",
    "Waiting Response": "Waiting Response",
    "Application Sent": "Application Sent",
    "In Review": "In Review",
    Reviewed: "Reviewed",
    Contacted: "Contacted",
    "Phone Screen": "Phone Screen",
    "First Interview": "First Interview",
    "Second Interview": "Second Interview",
    "Final Interview": "Final Interview",
    Hired: "Hired",
    Rejected: "Rejected",
    "Candidature envoyée": "Application Sent",
    "En entretien": "Interviewing",
    "Offre faite": "Offer Made",
    "Offre déclinée": "Declined Offer",
    "Attente réponse": "Waiting Response",
    "Rejeté /recruteur": "Rejected by Recruiter",
    Soumis: "Submitted"
  },
  finalDecisionTranslations: {
    Hired: "✅ Hired",
    "Not Hired": "❌ Not Hired",
    Declined: "🚫 Declined Offer",
    "No Answer": "⏳ No Answer",
    Rejected: "❌ Rejected",
    "Offer Accepted": "✅ Offer Accepted"
  },
  uiText: {
    pending: "Pending",
    brandMeta: "Enterprise",
    integDeelConnected: "✓ Connected",
    integDeelNotConnected: "✗ Not connected",
    integConnect: "Connect",
    integDisconnect: "Disconnect"
  },
  badgeText: {
    contactProgress: "Telephone + Email in progress",
    connectionAccepted: "Connection accepted"
  },
  ui: {
    notifMsgInterested: "✅ {name} is interested in the position",
    notifMsgRejected: "❌ {name} is not available for this position",
    notifTypeInterested: "Interested",
    notifTypeRejected: "Not available",
    notifTypeRecommendation: "Recommendation",
    notifTypeCvReceived: "Message",
    notifTypeOutreachSent: "Outreach sent",
    notifTypeStatusChanged: "Status",
    notifTypeAutoAdvance: "Auto-advance",
    notifTypeInterviewConfirmed: "Interview confirmed",
    notifMsgCvReceived: "📄 CV received via WhatsApp — {name}",
    notifMsgSlotProposed: "Slot requested: {datetime}",
    notifMsgSlotDeclined: "Candidate declined the proposed slots and wants other times.",
    notifMsgInterviewConfirmed: "Interview confirmed: {datetime}",
    notifUnread: "{count} unread",
    notifReply: "Reply",
    jdBtnGenerateAIAnalysis: "Analyze with AI",
    jdLabelAssignees: "Assign to",
    integConfigure: "Configure",
    entSaveError: "Couldn't save. Please try again.",
    notifLocalNote: "Saved on this device only",
    ruDelete: "Delete",
    ruDeleteTitle: "Delete unavailability",
    ruDeleteConfirm: "Delete this unavailability block? This can't be undone.",
    emilyAutoProposeTitle: "Automatic slot proposals",
    emilyAutoProposeDesc: "When a candidate confirms interest, Emily automatically proposes available slots.",
    emilyAutoProposeLabel: "Propose slots right after interest is confirmed",
    emilyWorkHoursTitle: "Available working hours",
    emilyWorkHoursDesc: "The time range within which Emily can propose interview slots.",
    emilyWorkHoursFrom: "From",
    emilyWorkHoursTo: "to",
    emilyHourSuffix: "h",
    emilyWorkDaysTitle: "Working days",
    emilyWorkDaysDesc: "Days on which interviews can be scheduled.",
    emilyDayMon: "Mon",
    emilyDayTue: "Tue",
    emilyDayWed: "Wed",
    emilyDayThu: "Thu",
    emilyDayFri: "Fri",
    emilyDaySat: "Sat",
    emilyDaySun: "Sun",
    twoFaTitle: "Two-factor authentication",
    twoFaDesc: "Add a time-based one-time code (TOTP) from an authenticator app as a second login step.",
    twoFaStart: "Set up authenticator",
    twoFaScan: "Scan this QR code with your authenticator app, then enter the 6-digit code.",
    twoFaSecret: "Or enter this key manually:",
    twoFaCodeLabel: "6-digit code",
    twoFaVerify: "Verify & enable",
    twoFaSuccess: "Two-factor authentication enabled.",
    twoFaError: "Couldn't set up 2FA. Please try again.",
    deactTitle: "Deactivate account",
    deactWarn: "This makes your account unconnectable by resetting your password to a random value. Your data is NOT deleted. You'll be signed out immediately. Contact support to restore access.",
    deactConfirmLabel: "Type to confirm:",
    deactConfirmWord: "DEACTIVATE",
    deactButton: "Deactivate my account",
    deactSuccess: "Account deactivated. Signing you out.",
    deactError: "Couldn't deactivate the account. Please try again.",
    integMissingConfig: "Integration not configured",
    integComingSoon: "Integration coming soon",
    integConnectSuccess: "Connected",
    integDisconnected: "Disconnected",
    integError: "Connection error",
    actionAccept: "Accept",
    actionClearSelection: "Clear selection",
    actionDeleteRejected: "Permanently delete all rejected candidates",
    actionReject: "Reject",
    actionRemoveSkill: "Remove skill",
    actions: "Actions",
    add: "Add",
    all: "All",
    aqAddPipeline: "Reach out",
    aqAdded: "Added",
    aqAiScoring: "AI analysis in progress…",
    aqAllCities: "— All cities —",
    aqAllProfiles: "All profiles",
    aqAnalysed: "out of {n} analysed",
    aqAnalyzing: "Analyzing…",
    aqAutoDisplay: "Search results will appear here",
    aqBroaden: "Try broadening location or removing required skills",
    aqBroadenBtn: "See more results with less strict criteria",
    aqBroadenLoading: "Broadening search…",
    aqCardView: "▦ Cards",
    aqCity: "City",
    cityRecognizedLabel: "City recognized:",
    cityFreeLabel: "Free-text city — broadened search",
    aqRadius: "Radius (km)",
    aqClassified: "Sorted by compatibility score",
    aqCompanyWorked: "Worked at (company)",
    aqCompanyNever: "Never worked at (company)",
    aqCompanyOrHint: "or",
    aqCompanyPlaceholder: "Type a company, Enter…",
    aqCompanyRemove: "Remove",
    aqGroupRoleSkills: "Role & skills",
    aqGroupLocation: "Location",
    aqGroupExperience: "Experience & background",
    aqGroupRefine: "Refine results",
    aqSectorFilter: "Industry",
    aqSectorFilterHint: "Sector filter: keeps only profiles where at least one sector keyword (AI-generated from the JD) appears anywhere in the profile. Fail-open: if it empties everything, keeps all + alert.",
    aqSectorKeywords: "Sector keywords",
    aqSectorAddKeyword: "+ add a keyword",
    aqAdd: "Add",
    aqCompetitors: "Competitors",
    aqCompetitorsOf: "Competitors of",
    aqCompetitorsNoCompany: "Could not identify the company (select a job posting or type a company)",
    aqCompetitorsHint: "Fill with my company's competitors (AI)",
    aqCompetitorsNoEnterprise: "Recruiter's company not found",
    aqCompetitorsEmpty: "No competitor found",
    aqBenchmark: "Benchmark",
    aqCountry: "Country",
    aqCriteria: "Refine search criteria",
    aqMoreCriteria: "More criteria",
    aqCurrentCompany: "Current company",
    aqEnrich: "Lookup — get phone + email",
    aqExcludeSkills: "Exclude",
    aqFilterBySkill: "Filter by skill",
    aqJobTitle: "Job title",
    aqKeyMissing: "Search key not detected — restart the dev server to enable profile search.",
    aqListView: "☰ List",
    aqMinScore: "Minimum score",
    aqMustSkills: "Must-have (AND)",
    aqCompletionExhausted: "No relevant profiles left to fetch: {n} of {x} requested profiles shown.",
    aqCompletionQuota: "Result quota reached for this cycle: {n} of {x} requested profiles shown. Undelivered quota was returned.",
    aqCompletionCapped: "Safety cap reached: {n} of {x} requested profiles shown.",
    aqNoResult: "No profile found",
    aqNoStrictMatch: "No candidate matches 100% of the required skills",
    aqNoStrictMatchHint: "Turn off precision (less strict search) or remove a skill.",
    aqPipeline: "Already in pipeline",
    aqPipelineCount: "candidates in pipeline for this position",
    aqPositionLocation: "Position & Location",
    aqProfilesFound: "{n} profiles",
    aqQualityLevel: "Quality & Level",
    aqResults: "profiles found",
    aqResultsOf: "result(s) out of",
    aqScoreVsJob: "Score vs position",
    aqScoring: "Scoring…",
    aqSearch: "Launch search",
    aqPrecision: "Precision",
    aqWidgetTitle: "Refine criteria",
    aqJdParsing: "Analysing the job description…",
    aqSummaryExpand: "Show all",
    aqSummaryCollapse: "Show less",
    aqPageRole: "Role",
    aqPageSkills: "Skills",
    aqPageLocation: "Location",
    aqPageExperience: "Experience",
    aqPageCompanies: "Companies",
    aqPageSettings: "Settings",
    aqAvailableProfiles: "{n} profiles available",
    aqClose: "Close",
    aqSectorBlock: "Sector",
    aqFetchLimit: "Profiles per search",
    aqLoadMoreFE: "Find more candidates",
    aqSearchPlaceholder: "Name, email, title, skill, city…",
    aqSearching: "Searching…",
    aqStopSearch: "Stop",
    aqExportTop15: "Export (top 15)",
    aqSelectJob: "— Select a position to search —",
    aqSelectToStart: "Select a position to start the search",
    aqSenAllLevels: "— All levels —",
    aqSenCSuite: "C-Suite (CEO, CTO…)",
    aqSenDirector: "Director",
    aqSenJunior: "Junior / Entry level",
    aqSenManager: "Manager",
    aqSenMid: "Mid (2–5 yrs)",
    aqSenSenior: "Senior (5+ yrs)",
    aqSenVP: "Vice-President",
    aqSeniority: "Seniority level",
    aqShouldSkills: "Nice-to-have (OR)",
    aqSkills: "Skills",
    aqSortBy: "Sort by",
    aqSortByName: "Name A → Z",
    aqSortByScore: "Score ↓",
    aqStrictMatch: "Strict match · 100%",
    aqSubtitle: "Search profiles and score them",
    aqTitle: "Advanced Search",
    aqTopProfiles: "Top {n} best profiles",
    aqWithPhoto: "With profile photo",
    asAddToPipeline: "Add to pipeline",
    asAddedToP: "Added to pipeline",
    asAddingToP: "Adding…",
    asEnrichMayTakeTime: "Enrichment may take a few seconds…",
    asAlreadyInP: "Already in your pipeline",
    asAnalyzingCandidates: "Analyzing {count} candidates",
    asAnalyzingProfile: "Analyzing profile…",
    asCerts: "Suggested certifications:",
    asCompatWith: "Compatibility with",
    asConsider: "~ To consider",
    asEmergingSkills: "Emerging skills:",
    asExperience: "Professional experience",
    asHighDemand: "In-demand skills:",
    asInYourPipeline: "In your pipeline",
    asInterviewPrep: "Interview preparation",
    asJ1Tasks: "Ready from day 1",
    asMarket: "Market & development",
    asMatch: "✓ Recommended",
    asMatchingSkills: "Matching skills",
    asMissingSkills: "Missing skills",
    asMustHaveSkills: "Must Have Skills",
    asMyCandidates: "My Candidates",
    asNoAdditionalResults: "No additional results found with relaxed criteria.",
    asNoCandidate: "No candidate in your pipeline",
    asNoContacts: "No contact info found.",
    asNoMatch: "✗ Not recommended",
    asNoUrlResult: "No profile found for this LinkedIn URL.",
    psySendTest: "Send the test",
    psyWaMessage: "Hello {name},\n\nAs part of your application for the position of {poste}, for which you have been shortlisted, we invite you to complete the following assessment test.\n\nYou can access the test via this link: {link}\n\nThank you in advance for your participation.\n\nKind regards,\n{signer}",
    psyTestSubject: "Invitation to complete your assessment test",
    teamJobTitle: "Job title",
    teamPhone: "Phone",
    teamEditContact: "Edit title & phone",
    psyNoPhoneLinkCopied: "No phone number — link copied to clipboard.",
    psyAssignError: "Could not create the test link.",
    psyTestSent: "Test sent.",
    sessionKickedBanner: "You were signed out because your account was opened on another device.",
    psyTestTitle: "Career interest test",
    psyTestSubtitle: "For each activity, indicate how much it fits you.",
    psyTestNamePh: "Your name",
    psyTestDreamPh: "Your dream job (optional)",
    psyTestScaleLow: "Not at all",
    psyTestScaleHigh: "Totally",
    psyTestSubmit: "Send my test",
    psyTestSubmitting: "Computing…",
    psyTestThanks: "Thank you!",
    psyTestThanksDesc: "Your profile has been sent to the recruiter.",
    psyTestStart: "Start",
    psyTestNext: "Next",
    psyScale4: "It is very unlikely I would behave this way",
    psyScale5: "I usually do not behave this way",
    psyScale6: "I tend not to behave this way",
    psyScale7: "I am neutral",
    psyScale8: "I tend to behave this way",
    psyScale9: "I usually behave this way",
    psyScale10: "It is very likely I would behave this way",
    psyTestBack: "Back",
    psyTestLoading: "Loading the test…",
    psyTestError: "We couldn't load the test.",
    psyTestRetry: "Try again",
    psyTestInvalid: "This link is no longer valid.",
    psyTestInvalidDesc: "Ask your recruiter for a new invitation link.",
    psyTestEmpty: "This test has no questions yet.",
    psyTestEmptyDesc: "Please check back a little later.",
    psyTestChipAnon: "Anonymous",
    psyTestChipNoWrong: "No right or wrong answers",
    psyTestChipSpontaneous: "Answer spontaneously",
    psyTestIntroLead: "This short test explores your professional interests to help clarify the paths that fit you best. There are no right or wrong answers, so answer spontaneously, based on what feels most like you.",
    psyTestPrivacyNote: "Your individual answers aren't shared directly with the recruiter. They're used to build your career profile (your motivations and strengths), and it's that final analysis that's shared with them.",
    psyScaleGuideTitle: "How to answer",
    psyScaleGuideLead: "Each question is a statement. You pick how much it sounds like you, from the smallest circle (not at all) to the largest (totally). The middle level is neutral.",
    psyScaleGuideCta: "Got it, start",
    psyTestNameLabel: "Your name",
    psyTestDreamLabel: "Dream job",
    psyTestProgressLabel: "Question",
    psyTestSubmitError: "We couldn't send your answers. Please try again.",
    psyAssignBtn: "Request the test",
    psyAssignCopy: "Copy link",
    asLinkedInLookupLimited: "Enriched LinkedIn lookup unavailable (enrichment quota reached).",
    asPosition: "Position",
    asPresent: "Present",
    asRemoveSkill: "Remove skill",
    asReset: "Reset",
    asScoreJd: "Score JD",
    asScoring: "Scoring…",
    asSearchLinkedIn: "Search by LinkedIn profile",
    asSearchUrl: "Search candidate by LinkedIn URL…",
    asSearchingContacts: "Searching (emails / phones)…",
    asSelectJD: "Select a position to add",
    asShouldHaveSkills: "Should Have Skills",
    asStrongMatch: "★ Strongly recommended",
    asTechSkills: "Technical skills",
    asTrainingNeeds: "Training needed",
    asViewCards: "Cards",
    asViewList: "List",
    asViewMoreProfiles: "View the {n} other analyzed profiles",
    back: "Back",
    calendarAEmbaucher: "To hire",
    calendarAPlanifier: "To schedule",
    calendarApril: "April",
    calendarAugust: "August",
    calendarCancel: "Cancel",
    calendarContactDone: "✅ Contact made",
    calendarContactLegend: "Contact made",
    calendarDecember: "December",
    calendarEditRdv: "Edit appointment",
    calendarFebruary: "February",
    calendarFriday: "Fr",
    calendarJanuary: "January",
    calendarJuly: "July",
    calendarJune: "June",
    calendarMarch: "March",
    calendarMay: "May",
    calendarMonday: "Mo",
    calendarNotesPlaceholder: "Notes on discussion, key points discussed…",
    calendarNovember: "November",
    calendarOctober: "October",
    calendarRdvDate: "Appointment date",
    calendarRdvPlanned: "📅 Scheduled appointment",
    calendarRdvPlannedLegend: "Scheduled appointment",
    calendarRejected: "Rejected",
    calendarReport: "Report",
    calendarRevision: "In review",
    calendarSaturday: "Sa",
    calendarSave: "Save",
    calendarSaving: "Saving…",
    calendarScheduled: "Scheduled",
    calendarSeptember: "September",
    calendarStatus: "Status",
    calendarSunday: "Su",
    calendarThursday: "Th",
    calendarTitle: "Appointment Calendar",
    calendarToContact: "To contact",
    calendarTuesday: "Tu",
    calendarWaiting: "Waiting",
    calendarWednesday: "We",
    cancel: "Cancel",
    cipTitle: "Propose slots",
    cipLoading: "Loading slots…",
    cipNoSlots: "No slot available in the next 14 days.",
    cipSelectSlots: "Select slots",
    cipSelected: "selected",
    cipMessageLabel: "WhatsApp message",
    cipNoPhone: "(no phone)",
    cipSelectPlaceholder: "Select one or more slots…",
    cipSubmitting: "Sending…",
    cipSubmitWhatsApp: "Propose & send WhatsApp",
    cipSubmitOnly: "Propose slot",
    cipSuccess: "{n} slot(s) proposed!",
    cipError: "Error proposing slot",
    ccmAssistant: "HR Assistant",
    ccmPosition: "Position:",
    cdmAssign: "Assign",
    cdmGenError: "Error during generation",
    cdmNoJD: "Candidate without assigned position",
    cdmSelectJD: "— Select a position —",
    cjsAllJobs: "All jobs",
    cjsApplied: "Applied",
    cjsAppliedFilter: "Applied",
    cjsCandidate: "Candidate",
    cjsCityRegion: "City / region",
    cjsCountry: "Country",
    cjsDaysAgo: "{n} days ago",
    cjsDescription: "Description",
    cjsFindRecruiter: "Find recruiter on LinkedIn",
    cjsLaunchSearch: "Search",
    cjsLoading: "Loading matched jobs…",
    cjsLocation: "Location (e.g. Paris, Lyon…)",
    cjsMarkApplied: "Mark as applied",
    cjsMinScore: "Min score",
    cjsMonthsAgo: "{n}mo ago",
    cjsNewSearch: "New job search",
    cjsNoResult: "No jobs found",
    cjsNoResultDesc: "Widen your criteria or lower the minimum score.",
    cjsRecruiterFound: "Recruiter identified",
    cjsSaveForLater: "Save for later",
    cjsSaved: "Saved",
    cjsSavedFilter: "Saved",
    cjsSearchCandidate: "Job title, candidate, city…",
    cjsSearching: "Searching…",
    cjsSearchingRecruiter: "Searching for recruiter…",
    cjsSelectCandidate: "Select a candidate",
    cjsSubtitle: "LinkedIn jobs matching your job descriptions",
    cjsTargetCandidate: "Target candidate",
    cjsTitle: "Matched Jobs",
    cjsToday: "Today",
    cjsVectorScore: "Vector compatibility score",
    cjsViewLinkedIn: "View LinkedIn profile",
    cjsViewOnLinkedIn: "View on LinkedIn",
    cjsWeeksAgo: "{n}w ago",
    cjsYesterday: "Yesterday",
    close: "Close",
    confirm: "Confirm",
    convAssistantTagline: "AI assistant · Always available",
    convClosed: "Conversation ended.",
    convEmilyManaging: "Emily is managing this conversation",
    convEmilyTab: "Emily",
    convEmpty: "No conversations",
    convHandBack: "Hand back to Emily",
    convJobUndefined: "Undefined position",
    convLoading: "Loading conversation…",
    convMessagesHeader: "Messages",
    convModeAll: "All",
    convModeClosed: "Closed",
    convModeRecruiter: "Recruiter",
    convMsgPlaceholder: "Your message to the candidate…",
    convNoEmily: "No Emily conversation",
    convNoMessages: "No messages yet",
    convNoWhatsApp: "No WhatsApp conversation",
    convOpenChat: "Open chat",
    convPhoneMissing: "Phone number missing for this candidate",
    convReplyPlaceholder: "Reply via WhatsApp…",
    convSearchPlaceholder: "Search…",
    convRoleCandidate: "Candidate",
    convRoleRecruiter: "Recruiter",
    convModeEmily: "Emily",
    convModeTerminated: "Ended",
    convTranslate: "Translate",
    convTranslating: "Translating…",
    convShowOriginal: "Show original",
    convSelectConversation: "Select a conversation",
    convSelectWhatsApp: "Select WhatsApp number",
    convTakeOver: "Take over",
    convUnknownCandidate: "Unknown candidate",
    convWhatsAppTab: "WhatsApp",
    cvAICompatibility: "AI Analysis · Compatibility",
    cvAllJobs: "All positions",
    cvAnalyze: "Analyze CV",
    cvCertifications: "Certifications",
    cvCompatLabel: "Compatibility",
    cvDownload: "Download PDF",
    cvEducation: "Education",
    cvEmpty: "No profile found",
    cvEmptyDesc: "Adjust your search or import CVs.",
    cvExperience: "Experience",
    cvFitScore: "TrueCalling Fit Score",
    cvFormation: "Education",
    cvGenerate: "Generate CV",
    cvGenerateCv: "Generate AI CV",
    cvGenerating: "Generating…",
    cvGeneratingLong: "Generating optimized CV…",
    cvLanguages: "Languages",
    cvLibrarySearch: "Name, title, skill, city…",
    cvLibraryTitle: "CV Library",
    fuStatusPool: "Vivier",
    cvFilterAll: "All",
    cvFilterPool: "Vivier",
    cvFilterActive: "Active",
    cvSelectedCount: "selected",
    cvEnrichSelection: "Enrich selection",
    cvClearSelection: "Clear",
    cvSearchedFor: "Searched for:",
    cvEnrichInProgress: "Enriching…",
    cvEnrichStarted: "Enrichment started — contacts will fill in shortly",
    cvEnrichFailed: "Enrichment failed",
    cvEnrichNoTarget: "No enrichable profile in selection",
    cvLoadingDB: "Loading your data…",
    cvMatchingSkillsLabel: "✅ Matched skills",
    cvMissingSkillsLabel: "❌ Missing skills",
    cvNoCV: "No CV generated yet",
    cvOpenProfile: "Open profile",
    cvSendToPipeline: "Send to pipeline",
    cvOptimizedSkills: "Optimized skills",
    cvOptimizedTitle: "CV optimized by TrueCalling AI",
    cvOriginalDownload: "Original CV",
    cvPhone: "Phone",
    cvProfilesAnalyzed: "profiles analyzed by TrueCalling AI",
    cvRegenerate: "Regenerate",
    cvRegenerateCv: "Regenerate CV",
    cvSearch: "Search a candidate or position…",
    cvSkills: "Skills",
    cvSubtitle: "CVs generated by Emily",
    cvSummary: "Summary",
    cvTargetJob: "Target job",
    cvTitle: "Emily's CV Library",
    cvUnknownCandidate: "Unknown candidate",
    cvUpdatedAt: "Updated",
    dbAccepted: "Accepted",
    dbAllUpToDate: "All up to date!",
    dbApplied: "Applied",
    dbByJob: "By Job",
    dbByPriority: "By Priority",
    dbByRecruiter: "By Recruiter",
    dbByTeam: "By Team",
    dbCandidates: "Candidates",
    dbCount: "Count",
    dbEnrich: "Enrich →",
    dbEnterpriseId: "Enterprise ID",
    dbError: "Error",
    dbGetContacts: "Get contacts →",
    dbHighPriority: "HIGH (Score ≥ 70%) — Ready to follow up",
    dbJDs: "JDs",
    dbJdStatsTooltip: "View detailed statistics",
    dbJobDesc: "Job Desc.",
    dbJobTitle: "Job Title",
    dbKept: "Kept",
    dbLowPriority: "LOW (Not yet scored)",
    dbMediumPriority: "MEDIUM (Score 1-69%) — To score & evaluate",
    dbMoreItems: "{count} more →",
    dbNoData: "No data",
    dbNoDataAvailable: "No data available",
    dbNoJDMatch: "No matching position",
    dbNoJobsSearch: "No jobs match your search.",
    dbNoNotifications: "No notifications",
    dbNoTeams: "No teams or job descriptions available.",
    dbNoTeamsJDs: "No positions for your team",
    dbNotifications: "Notifications",
    dbOpenConversation: "View conversation",
    dbMessageUnreadable: "(unreadable message)",
    dbRecommendations: "Internal repositioning",
    dbMessagesReceived: "Messages received",
    dbPending: "Pending",
    dbPipelineTab: "Pipeline",
    dbPriorityDesc: "Candidates are prioritized by their matching score. HIGH = ready for outreach; MEDIUM = needs evaluation; LOW = needs scoring.",
    dbRecruiter: "Recruiter",
    dbRejected: "Rejected",
    dbScoreNow: "Score now →",
    dbSearch: "Search by Reference ID...",
    dbSearchJDPlaceholder: "Search a position…",
    dbShowLess: "Show less ←",
    dbShowStats: "Show Stats",
    dbStatistics: "Statistics",
    dbStatus: "Status",
    dbSubtitle: "Light screen · Scores always visible · Drag & drop ranking",
    dbTeam: "Team",
    dbTeams: "Teams",
    dbTitle: "Enterprise Dashboard",
    dbUrgencies: "Urgencies",
    dbViewGaps: "View gaps →",
    delete: "Delete",
    edit: "Edit",
    email: "Email",
    emilyAiProviderDesc: "AI model used for Emily's responses",
    emilyAiProviderTitle: "AI Provider",
    emilyAllReviewed: "✓ All confirmations reviewed",
    emilyAssistantTitle: "HR Assistant",
    emilyAutoProgDesc: "Emily automatically progresses candidates through stages",
    emilyAutoProgTitle: "Automatic Progression",
    emilyAutoTransition: "Auto-transition",
    emilyCall: "Call",
    emilyCommunicationModeDesc: "How Emily interacts with candidates",
    emilyCommunicationModeTitle: "Communication Mode",
    emilyContextDesc: "Additional context Emily uses to personalize responses",
    emilyContextPlaceholder: "e.g. We are a fast-growing startup…",
    emilyContextTitle: "Context & Instructions",
    emilyConversations: "Emily Conversations",
    emilyCopied: "Copied!",
    emilyCopy: "Copy",
    emilyEnrichFirst: "Enrich the profile first.",
    emilyError: "Error loading configuration",
    emilyErrorMessage: "Sorry, an error occurred. Please try again.",
    emilyForbiddenDesc: "Topics Emily must avoid in conversations",
    emilyForbiddenPlaceholder: "e.g. salary details, competitor names…",
    emilyForbiddenTitle: "Forbidden Topics",
    emilyJdEditMode: "JD Edit Mode",
    emilyLoading: "Loading Emily configuration…",
    emilyManualMode: "Manual",
    emilyManualTransitions: "Manual transitions",
    emilyMarkFollowUp: "Mark as follow-up",
    emilyNoEmail: "No email available for this candidate",
    emilyNoMessages: "No messages in this conversation",
    emilyNoPhone: "No phone number available for this candidate",
    emilyOpenEmail: "Open in email",
    emilyRegenerate: "Regenerate",
    emilySaved: "Saved",
    emilySearchPlaceholder: "Search candidates...",
    emilySelectConv: "Select a conversation to view messages",
    emilySend: "Send via API",
    emilySending: "Sending…",
    emilySent: "Sent!",
    emilySmartMode: "Smart",
    emilyThresholdDesc: "Minimum scores to progress candidates automatically",
    emilyThresholdHigh: "High",
    emilyThresholdLow: "Low",
    emilyThresholdMedium: "Medium",
    emilyThresholdRecommended: "Recommended",
    emilyThresholdTitle: "Score Thresholds",
    emilyToneDesc: "Define Emily's communication style",
    emilyTonePlaceholder: "e.g. Warm, professional, concise…",
    emilyToneTitle: "Tone & Personality",
    emilyWelcome: "Hi! I'm Emily, your AI HR assistant. I'm here to help you with recruitment, candidate evaluation, job descriptions, and HR best practices.",
    emilyWriting: "Emily is writing…",
    error: "Error",
    exCampaignName: "Q2 2026 Campaign",
    exEmailDomain: "@company.com",
    exEmailEnglish: "your@email.com",
    exHttpFull: "https://...",
    exHttpSimple: "https://",
    exPassword: "••••••••",
    exPhoneNumber: "+33600000000",
    exSkillsBackend: "Python, SQL, React, project management…",
    exSkillsCerts: "AWS, PMP, PRINCE2…",
    exSkillsFrontend: "React, TypeScript",
    exSkillsTech: "Node.js, GraphQL",
    exSkillsWordpress: "PHP, Wordpress",
    exZero: "0",
    feAiAnalysis: "AI Analysis · 3 dimensions",
    feAnalyzing: "Analyzing…",
    feCompareAi: "Compare AI engines",
    feDatabase: "Database",
    feExperience: "Experience",
    feFunctions: "Functions",
    feEducation: "Education",
    feLanguages: "Languages",
    feFit: "Fit",
    feMatchedSkills: "Matched skills",
    feMissingSkills: "Missing skills",
    feNoContacts: "No contact info found",
    feRescoring: "Re-score",
    feRetry: "Retry",
    feScore: "Score",
    feScoreIa: "Score with AI vs selected position",
    feScoring: "Scoring…",
    feSearching: "Searching…",
    aqcandAvailableSuffix: "profiles available",
    aqcandApproxNote: "(before experience filter)",
    aqcandCounting: "Counting…",
    aqcandFetchPrefix: "Fetch",
    feSelect: "Select",
    feSelected: "Selected",
    feSelecting: "Selecting…",
    feSkills: "Skills",
    filter: "Filter",
    filterByBotName: "Filter by bot name...",
    fsAccept: "Accept",
    fsAccepted: "Accepted",
    fsAcceptedFilter: "✓ Accepted",
    fsCollapse: "Collapse",
    fsCollapseAll: "Collapse all",
    fsCompatShort: "Compat.",
    searchRateWait: "Many searches in progress — resuming in {s} s",
    fsCompatibility: "Overall compatibility",
    fsDayOne: "Ready from day one",
    fsDigitalRep: "Digital reputation",
    fsDigitalRepShort: "D.Rep.",
    fsExpand: "View full detail",
    fsExpandAll: "Expand all",
    fsExperiences: "Experience",
    fsJdLabel: "Job description",
    fsJdPlaceholder: "— Select position —",
    fsLoadingCandidates: "Loading candidates…",
    fsMatchedSkills: "Matched skills",
    fsMissingSkills: "Missing skills",
    fsMsgSearch: "Name, position, city, email…",
    fsNoCandidate: "No candidate for this position",
    fsNoFilterMatch: "No candidate matches the active filters.",
    fsNoForJob: "No candidate found for this position.",
    fsRecommendation: "Recommendation",
    fsReject: "Reject",
    fsRejected: "Rejected",
    fsRejectedFilter: "✗ Rejected",
    fsResilShort: "Resil.",
    fsResilience: "Professional resilience",
    fsScoreAll: "Score all",
    fsScoring: "Scoring…",
    fsSelectJob: "Select a position to score candidates",
    fsSelectJobDesc: "Choose a job description to view and qualify associated candidates.",
    fsSkillsPresent: "Matched skills",
    fsStrengths: "Strengths",
    fsSubtitle: "Score and shortlist candidates",
    fsTitle: "Candidate Selection",
    fsTrainingNeeds: "Training needs",
    fsUnprocessed: "Unprocessed",
    fsWeaknesses: "Weaknesses",
    fsYearsExp: "yrs exp.",
    fuAcceptance: "Send acceptance",
    fuAllJobs: "All positions",
    fuAllSkills: "All skills",
    fuApply: "Apply",
    fuCancel: "Cancel",
    fuColumnTitle: "Follow-Up",
    fuCompatScore: "Compatibility score",
    fuContact: "Contact",
    fuConversation: "Conversation",
    fuDeadline: "Deadline",
    fuDecision: "Decision",
    fuDecisionAll: "All decisions",
    fuDecisionDeclined: "🚫 Offer declined",
    fuDecisionHired: "✅ Hired",
    fuDecisionNoAnswer: "⏳ No answer",
    fuDecisionNotHired: "❌ Not hired",
    fuFilterStatus: "Follow-up status",
    fuFilters: "Filters",
    fuFollowUpStatus: "Follow-up status",
    fuFreeMsg: "✍️ Free message",
    fuInProgress: "In progress",
    fuInternalNote: "Internal note",
    fuInviteTest: "🧪 Invite to test",
    fuLoading: "Loading…",
    fuMatchingSkills: "✅ Matching skills",
    fuMessage: "Message",
    fuMessageSent: "Message sent ✅",
    fuMessageType: "Message type",
    fuMissingSkills: "❌ Missing skills",
    fuMsgPlaceholder: "Type your message…",
    fuNoCandidate: "No candidate",
    fuNoMessage: "No messages yet",
    fuNoPhone: "No phone number",
    fuNoProfile: "No profile available",
    fuNoTitle: "(No title)",
    fuNoWaMessages: "No WhatsApp messages",
    fuNotePlaceholder: "Observations, next steps, decisions…",
    fuPendingActions: "pending action(s)",
    fuPipeline: "Pipeline",
    fuRecentExp: "Recent experience",
    fuRecipient: "Recipient number",
    fuSave: "Save",
    fuSaving: "Saving…",
    fuSearch: "Search a candidate…",
    fuSearchPlaceholder: "Search a candidate…",
    fuSend: "Send",
    fuSendError: "Send error",
    fuSendWA: "Send WhatsApp",
    fuSendWa: "Send via WhatsApp",
    fuSending: "Sending…",
    fuStats: "Stats",
    fuStatusAEmbaucher: "To hire",
    fuStatusAPlanifier: "To schedule",
    fuStatusAccepted: "Accepted",
    fuStatusAll: "All statuses",
    fuStatusRejected: "Rejected",
    fuStatusReplied: "Replied",
    fuStatusRevision: "In review",
    fuStatusScheduled: "Scheduled",
    fuStatusSourced: "Sourced",
    fuStatusToContact: "To contact",
    fuStatusWaiting: "Waiting",
    fuSubtitle: "Track candidate progress",
    fuTemplateAccepted: "✅ Acceptance template",
    fuTestInvite: "Send test invitation",
    fuTipEmail: "Send a follow-up email",
    fuTipFilters: "Filter candidates",
    fuTipLinkedIn: "View LinkedIn profile",
    fuTipMarkDone: "Mark as done",
    fuTipPhone: "Call the candidate",
    fuTipWaSend: "Send a WhatsApp message",
    fuTipWaTimeline: "View WhatsApp history",
    fuTipWaUnread: "Unread messages",
    fuTitle: "Follow-up",
    fuViewTimeline: "View timeline",
    fuWhatsApp: "WhatsApp",
    fuYears: "yrs",
    hdrAdministration: "Administration",
    hdrEstimatedScore: "Estimated score",
    hdrLanguage: "Language",
    hdrLogout: "Logout",
    hdrMarkAllSeen: "Mark all as read",
    hdrClearRead: "Clear read",
    hdrClearAll: "Clear all",
    hdrNoNotifications: "No notifications",
    hdrNotifications: "Notifications",
    hdrSettings: "Settings",
    hdrViewCV: "View CV",
    hdrViewProfile: "View profile",
    historiqueCvAnalysis: "CV Analysis",
    ipBackToPipeline: "Back to Pipeline",
    ipCandidate: "Candidate",
    ipInternalSelectHint: "Select a position to see internal candidates",
    ipInternalSubtitle: "Candidates from your team matching this position",
    ipInternalTitle: "Internal Match",
    ipNoInternalMatch: "No internal candidate matches this position",
    ipRecommend: "Recommend",
    ipRecommendNote: "Add a note",
    ipRecommendSend: "Send recommendation",
    ipRecommendSending: "Sending…",
    ipRecommendTitle: "Internal Recommendation",
    ipRecommended: "Recommended",
    ipSalaryHidden: "Confidential",
    ipSelectCandidate: "Select a candidate",
    ipSubtitle: "Identify internal candidates for open positions",
    ipTeam: "Team",
    ipTitle: "Internal Mobility",
    jdAIAnalysisLoading: "AI analysis in progress…",
    jdAIAnalysisTitle: "TrueCalling AI Analysis",
    jdAIAnalysisError: "AI analysis failed, please retry.",
    jdAICompanyType: "Company",
    jdAIHardSkills: "Technical skills",
    jdAIMotivations: "Expected motivations",
    jdAIExpectedSoftSkills: "Expected scores · soft skills (test)",
    jdAIRedFlags: "⚠️ Red flags",
    jdAISeniority: "Level",
    jdActionEnrich: "Enrich — retrieve phone/email",
    jdActionGenerateTempIds: "Generate temporary identifiers (no email)",
    jdActionRescore: "Relaunch AI scoring",
    jdActionScoreAI: "Score with AI",
    jdActionSendEmail: "Resend invitation by email",
    jdActive: "Active",
    jdActiveFilter: "Active",
    jdAllJobs: "All positions",
    jdAllTeams: "— all teams",
    jdAnalyzing: "Analyzing…",
    jdBtnActivate: "Activate",
    jdBtnAnalyzeAI: "Analyze with AI",
    jdBtnDeactivate: "Deactivate",
    jdBtnFindCandidates: "Find candidates",
    jdBtnNewPost: "New position",
    jdBtnNext: "Next",
    jdBtnReanalyze: "Re-analyze",
    jdBtnViewPipeline: "View pipeline",
    jdColMinScore: "Min score",
    jdColRecruiter: "Recruiter",
    jdColTitle: "Title",
    jdColType: "Type",
    cmdkPlaceholder: "Search or jump to…",
    cmdkNav: "Navigation",
    cmdkLanguage: "Language",
    cmdkNoResults: "No results",
    cmdkHint: "↑↓ to navigate · Enter to select · Esc to close",
    themeToggle: "Toggle light / dark",
    firstRunTitle: "Welcome to TrueCalling",
    firstRunIntro: "Four steps to your first hire.",
    frStepJd: "Create or import a job",
    frStepSearch: "Find candidates",
    frStepPipeline: "Track them in the pipeline",
    frStepEmily: "Let Emily reach out",
    firstRunGotIt: "Got it",
    pipelineToastPhoneError: "Failed to update phone",
    cvToastAnalysisFailed: "Analysis failed",
    waSendPlaceholder: "Write your message…",
    emilyToastLoadConvsError: "Failed to load conversations",
    emilyToastLoadConvError: "Failed to load conversation",
    emilyToastConfirmSaved: "Confirmation saved",
    emilyToastConfirmError: "Failed to save confirmation",
    jdCreatePost: "Create position",
    jdDelete: "Delete",
    jdDeleteConfirm: "Delete this job? It will be removed from the list but kept (stats preserved).",
    jdDetailCandidates: "Candidates",
    jdDetailCerts: "Certifications",
    jdDetailCreated: "Created on",
    jdDetailExpectations: "Expectations",
    jdDetailExternalCompany: "External company",
    jdDetailExternalLink: "External link",
    jdDetailLocationEmpty: "Location not specified",
    jdDetailRecruiter: "Recruiter",
    jdDetailResponsibilities: "Responsibilities",
    jdDetailSalary: "Salary",
    jdDetailSummary: "Summary",
    jdDetailTargetJobs: "Target positions",
    jdEdit: "Edit",
    jdEmptyStateMessage: "Adjust filters, import, or create your first position.",
    jdExCalendlyLink: "https://calendly.com/...",
    jdExDetailedDesc: "Detailed description of the role, context, team…",
    jdExFullDescription: "Job title, description, missions, required skills, location, salary…",
    jdExGeneratedAuto: "Auto-generated after creation",
    jdExJobTitle: "ex: Senior Data Analyst",
    jdExLeadershipSkills: "Leadership, communication, autonomy…",
    jdExLocation: "ex: Paris 8th, Lyon, Remote…",
    jdExQualifications: "Bachelor's degree, Masters, academic certifications…",
    jdExRecruiterEmail: "recruiter@company.com",
    jdExRefExample: "ex: REF-2024-001",
    jdExRequiredExperience: "Experience, degree, skills expected…",
    jdExResponsibility1: "• Responsibility 1\\n• Responsibility 2",
    jdExSalaryMax: "50000",
    jdExSalaryMin: "35000",
    jdExShortSummary: "Short summary about the position…",
    jdExTargetCareers: "Target careers this role can lead to…",
    jdExTrainingProgram: "Training program, modules, duration…",
    jdGoogleJobs: "Google Jobs search",
    jdImportOcrEmpty: "No text detected in the image",
    jdTeamFallback: "Team",
    jdExSkills: "Python, SQL, React, project management…",
    jdExCertifications: "AWS, PMP, PRINCE2…",
    jdExExtCompany: "Client company name",
    jdImport: "Import PDF",
    jdImportClickFile: "Click to select a file",
    jdImportDropHere: "or drag and drop here",
    jdImportExtracting: "Extracting…",
    jdImportNoImage: "Select an image",
    jdImportNoPdf: "Select a PDF file",
    jdImportNoText: "Paste text, select a PDF or an image",
    jdImportRequired: "Required field",
    jdImportTabOcr: "OCR Image",
    jdImportTabPaste: "Paste text",
    jdImportTitle: "Import a job description",
    jdDetectedLanguage: "Detected language:",
    jdLanguageMismatchDocument: "The document appears to be in",
    jdLanguageMismatchUI: "but your UI is in",
    jdWhichLanguageToParse: "Which language should I parse?",
    jdUseLanguage: "Use",
    jdInactive: "Inactive",
    jdInactiveFilter: "Inactive",
    jdLabelActivePost: "Active position",
    jdLabelAssignedTeam: "Assigned team",
    jdLabelCandidateURL: "Candidate URL (auto-generated)",
    jdLabelPublishBoard: "Publish on the public job board",
    jdHintPublishBoard: "Lists this position on truecalling.ai/jobs — discoverable by anyone.",
    jdLabelLinkedinRequired: "LinkedIn required on the apply form",
    jdHintLinkedinRequired: "If on, candidates must provide their LinkedIn URL to apply.",
    jdLabelCert: "Certifications required",
    jdLabelClientName: "Client company name",
    jdLabelCurrency: "Currency",
    jdLabelSalaryPeriod: "Period",
    jdSalaryPeriodAnnual: "Annual",
    jdSalaryPeriodMonthly: "Monthly",
    jdLabelDescription: "Full description",
    jdLabelEmailRef: "Contact email",
    jdLabelExpectation: "Expectations",
    jdLabelExtCompany: "External company name",
    jdLabelExtLink: "External application link",
    jdLabelJobTitle: "Job title",
    jdLabelKeyResp: "Key responsibilities",
    jdLabelMinScore: "Minimum score required",
    jdLabelQualifications: "Qualifications",
    jdLabelRecruiter: "Recruiter",
    jdLabelRefId: "Reference ID",
    jdLabelRemote: "Remote",
    jdLabelSalaryGrid: "Salary range",
    jdLabelSalaryMax: "Maximum salary",
    jdLabelSalaryMin: "Minimum salary",
    jdLabelSalaryText: "Salary (free text)",
    jdLabelSkills: "Required skills",
    jdLabelSoftSkills: "Soft skills",
    jdLabelSummary: "Job summary",
    jdLabelSyllabus: "Training syllabus",
    jdLabelTargetJobs: "Target job titles",
    jdLoadingDB: "Loading your data…",
    jdLocation: "Location",
    jdModalNew: "New position",
    jdNew: "New job description",
    jdNoAdvancedInfo: "No advanced information entered.",
    jdNoJD: "No job description yet",
    jdNoOcrText: "No text detected in image",
    jdNoPostFound: "No position found",
    jdNoTrainingInfo: "No training information entered.",
    jdPdfEmpty: "Empty or unreadable PDF (scanned PDF not supported)",
    jdRemoteBadge: "remote",
    jdRemoteHybrid: "Hybrid",
    jdRemoteOnsite: "On-site",
    jdRemoteRemote: "Remote",
    jdRequirements: "Requirements",
    jdResponsibilities: "Responsibilities",
    jdRoleMyCards: "My Positions",
    jdRoleTeamLeader: "Team Leader",
    jdSave: "Save",
    jdSearch: "Search…",
    jdSearchPlaceholder: "Search a job, a recruiter…",
    jdSubtitle: "Manage your job descriptions",
    jdTabAdvanced: "Advanced",
    jdTabDesc: "Description",
    jdTabInfo: "Information",
    jdTabTraining: "Training",
    jdTeamsAll: "All teams",
    jdTabAll: "All",
    jdTitle: "Job Descriptions",
    jdToggleActive: "Deactivate",
    jdToggleInactive: "Activate",
    jdViewHrAdmin: "HR View",
    jdViewOurJobs: "Our positions",
    jiApplied: "Applied",
    jiCandidateStatus: "Candidate status",
    jiCandidates: "Candidates",
    jiCompetencies: "Competencies",
    jiCvLibrary: "CV Library",
    jiDayOneTasks: "Day-One Tasks",
    jiEmailMissing: "Email missing",
    jiEmailOk: "Email ✓",
    jiFitScore: "Fit Score",
    jiFollowUp: "Follow-up",
    jiHide: "Hide",
    jiJobTitle: "Job Title",
    jiKept: "Kept",
    jiMatchedJobs: "Matched Jobs",
    jiMissingSkills: "Missing Skills",
    jiMotivations: "Motivations",
    jiNoCandidates: "No candidates yet for this job.",
    jiPending: "Pending",
    jiPhoneMissing: "Phone missing",
    jiPhoneOk: "Phone ✓",
    jiPipeline: "Pipeline",
    jiShow: "Show",
    jiUntitled: "Untitled",
    jiYearsExp: "y exp",
    loading: "Loading…",
    loadingConversation: "Loading conversation…",
    location: "Location",
    name: "Name",
    no: "No",
    noConversations: "No conversations",
    noConversationsFound: "No conversations found",
    noData: "No data",
    noResults: "No results",
    open: "Open",
    phone: "Phone",
    pipelineAllJobs: "All positions",
    pipelineArchive: "Archive",
    pipelineCalendar: "Appointments",
    pipelineChangeStatus: "Change status",
    pipelineClearRejected: "Clear rejected",
    pipelineConfirmAction: "Confirm action",
    pipelineDelete: "Delete",
    pipelineDone: "✓ Done",
    pipelineDuplicateDeleted: "Duplicate deleted",
    pipelineEnrich: "Enrich",
    pipelineEnrichAll: "Lookup all",
    pipelineEnriching: "Looking up…",
    pipelineScoreAll: "Score all",
    pipelineScoreAllTitle: "Re-score (deterministic, T=0) cards missing a score or notes",
    pipelineScoreAllNothing: "Nothing to score — everything is already complete",
    pipelineScoreAllNoJd: "Cards without a job cannot be scored",
    pipelineScoreAllDone: "{ok} scored · {complete} already complete · {orphan} without job · {failed} failed",
    pipelineScoring: "Scoring…",
    pipelineEnrichmentError: "Enrichment error",
    pipelineError: "Error",
    pipelineError2: "Something went wrong",
    pipelineFitScore: "Fit Score",
    pipelineFullNameRequired: "Full name required",
    pipelineFullenrichNotConfigured: "Enrichment not configured",
    pipelineGeneration: "Generation…",
    pipelineGenerationError: "Generation error",
    pipelineLinkedInSearch: "LinkedIn search",
    pipelineLinkedInUrlOrNameRequired: "LinkedIn URL or full name required",
    pipelineMatchedSkills: "✅ Matched skills",
    pipelineMissingSkills: "❌ Missing skills",
    pipelineMoveTo: "→ ",
    pipelineNoCandidate: "No candidate",
    pipelineNoEnrichSelection: "Select candidates to enrich",
    pipelineNotScored: "Not scored",
    pipelineNothingToProcess: "Nothing to process",
    pipelineOpenProfile: "Open full profile",
    dsarExportBtn: "Export",
    dsarExportBusy: "Exporting…",
    dsarEraseBtn: "Erase",
    dsarPreviewBusy: "Preview…",
    dsarExportTitle: "Export the candidate's data (GDPR art. 15/20)",
    dsarEraseTitle: "Permanently erase the candidate's data (GDPR art. 17)",
    dsarPdfTitle: "Personal data export — GDPR (art. 15/20)",
    dsarExportConfirmTitle: "Confidential export",
    dsarExportConfirmBody: "This is a confidential document linked to GDPR actions. Think carefully before sharing it.",
    dsarExportConfirmCta: "Export as PDF",
    dsarExportFailed: "Export failed",
    dsarEraseTitleModal: "GDPR erasure",
    dsarEraseWarning: "Definitive action linked to a GDPR request. This is NOT removing a candidate from the pipeline — to remove a candidate from the pipeline, move them to Rejected, then delete.",
    dsarEraseIntro: "Permanent and irreversible deletion of the linked data (preview):",
    dsarNoData: "No linked data found.",
    dsarReasonLabel: "Reason (required, logged):",
    dsarReasonPlaceholder: "e.g. candidate erasure request (DSAR)",
    dsarCancel: "Cancel",
    dsarConfirmErase: "Delete permanently",
    dsarErasing: "Deleting…",
    dsarDoneMsg: "Candidate data erased.",
    dsarClose: "Close",
    pipelinePhotos: "Photos",
    pipelinePreparation: "Preparation…",
    pipelineReScore: "Re-score",
    pipelineRefreshing: "Refreshing…",
    pipelineRetrievingContacts: "Retrieving contacts…",
    pipelineScoreAI: "Score with AI",
    pipelineScoreAndSkillsRequired: "Score and skills required",
    pipelineScoringFailed: "Scoring failed",
    pipelineSearch: "Search a candidate…",
    pipelineViewCards: "Cards",
    pipelineViewTable: "Table",
    pipelineFilterLocation: "Location",
    pipelineClear: "Clear",
    pipelineSelectAll: "Select all",
    pipelineSelectedCount: "{n} selected",
    pipelineBulkMoveTo: "Move to",
    pipelineColName: "Name",
    pipelineColTitle: "Title",
    pipelineColScore: "Score",
    pipelineColLocation: "Location",
    pipelineSelected: "selected",
    pipelineSelectedPosition: "Selected position",
    pipelineStatusInterview: "Interview",
    pipelineStatusOffer: "Offer",
    pipelineStatusPending: "Pending",
    pipelineStatusRejected: "Rejected",
    pipelineStatusReviewing: "In Review",
    pipelineSubtitle: "candidates · view by status",
    pipelineTitle: "Candidate Pipeline",
    pipelineUnassignedCandidates: "Unassigned candidates",
    pipelineUnassignedPosition: "No position",
    pipelineClosedPosition: "Closed position",
    jdDeactivateConfirm: "Deactivating this position will remove {count} candidate(s) from the default pipeline view. They stay available under the “Closed position” filter. Continue?",
    cvSentToClosedJd: "{name} was sent to the pipeline, but their position is closed: they will only appear under the “Closed position” filter.",
    pipelineClosedCandidates: "Candidates from a closed position",
    placeholderMessage: "Write your message… (Press Enter to send)",
    placeholderYourAnswer: "Your answer...",
    priorityViewPipelineLink: "View in Pipeline →",
    reset: "Reset",
    save: "Save",
    score: "Score",
    search: "Search",
    searchCandidates: "Search candidates...",
    searchClientEmail: "Search client or email…",
    send: "Send",
    sending: "Sending…",
    skills: "Skills",
    smdAiGenerate: "AI generate",
    smdAuthorizeEmily: "Authorize Emily to contact candidate",
    smdCancel: "Cancel",
    smdEmailCheckbox: "Email",
    smdMessageComposition: "Message composition",
    smdPhoneCheckbox: "Phone",
    smdSelectTemplate: "Select template",
    smdSend: "Send",
    smdSms: "SMS",
    smdTemplateSelection: "Template selection",
    smdWhatsapp: "WhatsApp",
    smdWriteFreely: "Write freely",
    stCalendlyLink: "Calendly link",
    stEmily: "Emily AI",
    stEnterprise: "Enterprise",
    stIntegrations: "Integrations",
    stNotifCandidateUpdate: "Candidate update",
    stNotifFollowUp: "Follow-up due",
    stNotifNewCandidate: "New candidate",
    stNotifPipeline: "Pipeline movement",
    stNotifScoreReady: "TrueCalling score ready",
    stNotifWeekly: "Weekly report",
    stNotifications: "Notifications",
    stProfile: "Profile",
    stSave: "Save changes",
    stSaved: "Saved",
    stSaving: "Saving…",
    stSecurity: "Security",
    stTeam: "Team",
    stTitle: "Settings",
    status: "Status",
    submissionsActionPlan: "Action Plan",
    submissionsAltRoles: "Alternative Roles",
    submissionsAnalyzing: "Analyzing…",
    submissionsCareerAlignment: "Career Alignment",
    submissionsClose: "Close",
    submissionsCompetencies: "Competencies",
    submissionsCvAnalysis: "CV Analysis",
    submissionsDevelopment: "Development",
    submissionsDomain: "Domain",
    submissionsDownloadPdf: "Download PDF",
    submissionsExperience: "Experience",
    submissionsGapsId: "Skills Gaps",
    submissionsGenSoftSkills: "Generated Soft Skills",
    submissionsGeneratedCv: "Generated CV",
    submissionsImprovements: "Improvements",
    submissionsInterpretAi: "AI Interpretation",
    jdcmpTitle: "Job Fit",
    jdcmpAnalyze: "Analyze fit",
    jdcmpReanalyze: "Re-analyze",
    jdcmpAnalyzing: "Analyzing…",
    jdcmpResolving: "Finding the linked job…",
    jdcmpNoJd: "No job linked to this test.",
    jdcmpNoJdPick: "No linked job — pick a job to compare.",
    jdcmpPickJd: "Choose a job…",
    jdcmpGlobalHint: "Overall candidate ↔ job fit score",
    jdcmpExpected: "Expected",
    jdcmpDimHint: "Candidate → expected · dimension compatibility",
    jdcmpStrengths: "Strengths",
    jdcmpConcerns: "Gaps",
    jdcmpTextLangHint: "Re-analyze to view this analysis in the current language.",
    jdcmpLabel_excellent: "Excellent",
    jdcmpLabel_good: "Good",
    jdcmpLabel_average: "Average",
    jdcmpLabel_weak: "Weak",
    submissionsLoading: "Loading…",
    submissionsMotivations: "Motivations",
    submissionsNoResults: "No Submissions",
    submissionsNoResultsDesc: "No submissions to analyze",
    submissionsProfileInterpretation: "Profile Interpretation",
    submissionsReanalyze: "Reanalyze",
    submissionsReport: "Report",
    submissionsSearchPlaceholder: "Search submissions…",
    submissionsSkillsId: "Identified Skills",
    submissionsSoftSkills: "Soft Skills",
    submissionsStatusAll: "All",
    submissionsStatusComplete: "Complete",
    submissionsStatusCount: "status",
    submissionsStatusCounts: "statuses",
    submissionsStrengths: "Strengths",
    submissionsSubtitle: "Analyze candidate submissions",
    submissionsTableCandidate: "Candidate",
    submissionsTableCvScore: "CV Score",
    submissionsTableDate: "Date",
    submissionsTableDream: "Dream Role",
    submissionsTableTopComp: "Top Competency",
    submissionsTableTopMot: "Top Motivation",
    submissionsTitle: "Submissions",
    submissionsYear: "year",
    submissionsYears: "years",
    success: "Saved",
    urgenRecommendedBy: "Recommended by {name}",
    view: "View",
    viewCalendar: "View appointment calendar",
    viewGrid: "Grid view",
    viewList: "List view",
    yes: "Yes",
    eawJobSummary: "Job Summary",
    eawKeyResponsibilities: "Key Responsibilities",
    eawRequiredSkills: "Required Skills (must-have)",
    eawQualifications: "Qualifications",
    eawSoftSkills: "Soft Skills",
    eawAssistantTitle: "HR Assistant",
    jdPHJobTitle: "e.g. Senior Data Analyst",
    jdPHRefId: "e.g. REF-2024-001",
    jdPHLocation: "e.g. Paris, Lyon, Remote…",
    jdPHEmail: "recruiter@company.com",
    jdPHCandidateUrl: "Auto-generated after creation",
    jdImportTabPdf: "Import PDF",
    jdImportOcrDesc: "Import an image or scan of your job description. OCR will extract the text automatically.",
    jdImportTextDesc: "Paste the raw text of your job description. AI will automatically extract and structure all fields.",
    jdImportPdfDesc: "Text will be extracted automatically. Compatible with text PDFs (not scanned).",
    jdImportClickToChange: "KB · Click to change",
    jdImportFormats: "JPG, PNG, GIF, WebP…",
    jdImportTextPlaceholder: "Job title, description, responsibilities, required skills, location, salary…",
    jdImportCharCount: "characters",
    wapRefresh: "Refresh",
    wapNoMessages: "No WhatsApp messages for this candidate.",
    wapNoPhone: "No phone number available.",
    wapLoadError: "Loading error",
    wapSendError: "Send error",
    wapTypePlaceholder: "Write a message…",
    wapYesterday: "Yesterday",
    cdmFollowupTitle: "Candidate follow-up",
    cdmContactStatus: "Contact status",
    cdmInternalNote: "Internal note",
    cdmNotePlaceholder: "Follow-up note…",
    cdmFollowupDue: "Follow-up before",
    cdmSave: "💾 Save follow-up",
    cdmSaving: "Saving…",
    cdmChangeStatus: "Change status",
    cdmAnalyzing: "Analyzing…",
    jdmViewAllSkills: "View candidates with all skills",
    jdmRelaunch: "Re-run search",
    jdmExportCSV: "Export CSV (2 files)",
    jdmRetry: "Retry",
    jdmLoadingCache: "Loading cache…",
    jdmSearching: "Search in progress…",
    jdmMarketPool: "Market pool — Database",
    jdmCompatibility: "Candidates × skills compatibility",
    epSendError: "Send error",
    epGenError: "Generation error. Retry.",
    epLoadingTemplates: "Loading templates…",
    epNoTemplates: "No WhatsApp template configured. Check Twilio keys in Supabase.",
    cdmWhyScore: "Why this score?",
    cdmViewAnalysis: "View analysis",
    cdmScoreAnalysis: "Score analysis",
    cdmHide: "Hide",
    cdmRelevant: "Relevant",
    cdmAdjacent: "~ Adjacent",
    cdmCriticalGaps: "Critical gaps",
    cdmInterviewPrep: "Interview preparation",
    cdmTestResult: "Test result",
    cdmBehavioralQ: "Behavioral questions",
    cdmTechnicalQ: "Technical questions",
    cdmRecruiterFocus: "Recruiter focus areas",
    cdmMarketDemand: "Market demand",
    cdmInDemand: "In demand:",
    cdmEmerging: "Emerging:",
    cdmRecommendedCerts: "Recommended certifications",
    cdmLanguages: "Languages",
    cdmLastContact: "Last contact:",
    cdmChangeStatus2: "▼ Change status",
    jdmCandidatesInPipeline: "candidate(s) in pipeline",
    jdmSkillsRequired: "skill(s) required",
    jdmAllSkillsShort: "all skills",
    jdmDownloadPDF: "Download PDF",
    jdmSkillsDetected: "skill(s) detected",
    jdmSaved: "✓ Saved",
    jdmProfilesAnalyzed: "profiles analyzed",
    jdmKpiProfiles: "Profiles analyzed",
    jdmKpiAllSkills: "All skills",
    jdmSkill: "Skill",
    jdmCandidates: "Candidates",
    jdmNoSkillsError: "No skills detected on candidates — cannot start search.",
    jdmNoResults: "Search completed but no candidates found for \"{title}\".",
    jdmCompatibilityTitle: "Candidates × skills compatibility (internal pipeline)",
    jdmNoCandidates: "No candidates in pipeline for this JD.",
    jdmNoSkillsMatrix: "No skills detected to build the matrix.",
    jdmCandidate: "Candidate",
    jdmYes: "Yes",
    jdmNo: "No",
    plArchiveConfirm: "Archive {count} candidate(s)? This action is irreversible from this view.",
    plContactAdded: "Contact info added",
    plContactError: "Error adding contact",
    plEnriched: "{name} — enriched ({emails} email(s), {phones} phone(s))",
    plDeleteRejected: "Permanently delete {count} rejected candidate(s)?",
    plDeleteRejectedTitle: "Permanently delete all rejected candidates",
    plCalendarTitle: "View appointment calendar",
    plOrphanJdAttached: "attached to",
    plOrphanJdCreated: "new JD created:",
    plProposeSlots: "Propose slots",
    plSlotsDeclined: "Slots declined by candidate",
    plReproposeSlots: "Re-propose slots",
    plDuplicatesDetected: "{count} duplicate group(s) detected",
    plDuplicateEntries: "({count} entries for the same JD)",
    acmTitle: "Add contact info — {name}",
    acmEmailLabel: "Email (optional)",
    acmPhoneLabel: "Phone (optional)",
    acmPhonePlaceholder: "+33 6 12 34 56 78",
    acmCurrentContacts: "Current contact info:",
    acmValidationError: "Please enter at least one email or phone number",
    acmSaveError: "Error saving contact",
    acmCancel: "Cancel",
    acmSave: "Save",
    aiActive: "Active",
    aiDesc: "Select the AI provider for scoring and analysis",
    aiNote: "Each provider has different capabilities. Change anytime.",
    aiP1Badge: "Fast",
    aiP1Desc: "Quick responses, excellent for real-time scoring",
    aiP2Badge: "Advanced",
    aiP2Desc: "Nuanced analysis and complex reasoning",
    aiP3Badge: "GDPR-native",
    aiP3Desc: "Data stays in Europe, full GDPR compliance",
    aiP4Badge: "Specialized",
    aiP4Desc: "Optimized for behavioral and skill analysis",
    aiSelect: "Select",
    aiTitle: "AI Provider",
    aiUpdated: "AI provider updated",
    entAbout: "About the company",
    entCandidateSpace: "Allow candidate workspace",
    entCandidateSpaceDesc: "Let candidates access their own profile and interview prep",
    entDesc: "Manage company details and settings",
    entEmailSuffix: "Email domain suffix",
    entName: "Company name",
    entTitle: "Enterprise Settings",
    entWebsite: "Website",
    entWhatsapp: "WhatsApp number",
    integCalendlyDesc: "Schedule and manage interviews with Calendly integration",
    integCalendarDesc: "Sync interviews with Google Calendar",
    integOutlookDesc: "Sync interviews with Outlook Calendar",
    integConnect: "Connect",
    integDeelConnected: "✓ Connected",
    integDeelNotConnected: "✗ Not connected",
    integDesc: "Manage your integrations",
    integDisconnect: "Disconnect",
    integLinkedInDesc: "Search and recruit directly from LinkedIn",
    integSlackDesc: "Get notifications and updates in Slack",
    integTitle: "Integrations",
    mcpKeysTitle: "MCP keys",
    mcpKeysDesc: "Personal keys to connect AI assistants (Claude, Copilot Studio, ChatGPT) to your TrueCalling account. Each key acts as you — row-level security applies.",
    mcpKeysGenerate: "Generate a key",
    mcpKeysGenerating: "Generating…",
    mcpKeysNamePlaceholder: "Name (e.g. Claude, Copilot Studio)",
    mcpKeysOnce: "This key is shown only once. Store it like a password.",
    mcpKeysCopy: "Copy",
    mcpKeysCopied: "Key copied",
    mcpKeysDone: "Done",
    mcpKeysNameCol: "Name",
    mcpKeysKeyCol: "Key",
    mcpKeysCreated: "Created",
    mcpKeysLastUsed: "Last used",
    mcpKeysNever: "Never",
    mcpKeysStatus: "Status",
    mcpKeysActive: "Active",
    mcpKeysRevoked: "Revoked",
    mcpKeysRevoke: "Revoke",
    mcpKeysRevokeConfirm: "Revoke this key? Apps using it lose access within 5 minutes.",
    mcpKeysEmpty: "No MCP key yet.",
    mcpKeysNoUser: "Not signed in.",
    integWhatsAppDesc: "Send messages and conduct interviews via WhatsApp",
    deelConnected: "Deel connected",
    deelConnectSuccess: "Connected to Deel",
    deelClientIDError: "Deel Client ID not configured",
    deelNoEnterprise: "Your account is not associated with an enterprise. Contact support.",
    deelError: "Error",
    deelPopupBlocked: "Popup blocked - check your browser settings",
    navAI: "AI Provider",
    navEmily: "Emily AI",
    navEnterprise: "Enterprise",
    navIntegrations: "Integrations",
    navNotifications: "Notifications",
    navSecurity: "Security",
    navTeam: "Team",
    notifCandidateUpdate: "Candidate updates",
    notifDesc: "Control how you receive notifications",
    notifFollowUp: "Follow-ups due",
    notifNewCandidate: "New candidates",
    notifPipeline: "Pipeline movements",
    notifScoreReady: "Scores ready",
    notifTitle: "Notifications",
    notifSectionPlanning: "Interview planning",
    notifNoApproved: "No confirmed interview",
    notifNoPending: "No slots pending approval",
    notifSectionRejected: "Rejected history",
    notifSectionApproved: "Confirmed interviews",
    notifSectionProposed: "Interview slots pending validation",
    notifJd: "JD",
    notifRecommendation: "Recommendation",
    notifUnknownCandidate: "Unknown candidate",
    notifEvents: "event(s)",
    notifActionError: "Error",
    notifRejected: "Slot rejected",
    notifApproved: "Slot approved",
    notifReject: "Reject",
    notifApprove: "Approve",
    notifMonthNext: "Next month",
    notifMonthPrev: "Previous month",
    notifWeekNext: "Next week",
    notifWeekPrev: "Previous week",
    notifLayout_month: "Month",
    notifLayout_week: "Week",
    notifLayout_list: "List",
    notifCat_cancelled: "Cancelled",
    notifCat_recommendation: "Recommendations",
    notifCat_rejected: "Rejected",
    notifCat_approved: "Approved",
    notifCat_proposed: "Proposed",
    notifCat_all: "All",
    notifYesterday: "Yesterday",
    notifTomorrow: "Tomorrow",
    notifToday: "Today",
    notifEmpty: "No notifications",
    notifLoading: "Loading…",
    notifSubtitle: "Interview planning and recommendations",
    notifWeekly: "Weekly reports",
    pageSubtitle: "Manage company, team, integrations, and security",
    pageTitle: "Settings",
    saved: "Saved",
    saving: "Saving…",
    sec2FABtn: "Enable 2FA",
    sec2FADesc: "Add two-factor authentication for extra security",
    sec2FATitle: "Two-Factor Authentication",
    secChangeBtn: "Change Password",
    secChanging: "Changing…",
    secConfirm: "Confirm new password",
    secDangerDesc: "Permanently delete your account and all associated data",
    secDangerTitle: "Danger Zone",
    secDeleteBtn: "Delete Account",
    secDesc: "Manage your account security",
    secErrEmpty: "Password cannot be empty",
    secErrLength: "Password must be at least 8 characters",
    secErrMismatch: "Passwords do not match",
    secNewPassword: "New password",
    secSuccessMsg: "Password changed successfully",
    secTitle: "Security",
    teamCalendlyBtn: "Edit Calendly",
    teamDelPrefix: "Delete",
    teamDelSuffix: "from team?",
    teamDelTitle: "Confirm deletion",
    teamDesc1: "member",
    teamDescN: "members",
    teamEmail: "Email",
    teamFullName: "Full name",
    teamInviteTitle: "Invite team member",
    teamNoMembers: "No team members yet",
    teamRole: "Role",
    teamRoleAdmin: "Admin",
    teamRoleMember: "Member",
    teamTitle: "Team Members",
    opTitle: "External Repositioning",
    opNoJobTitle: "Enter a job title to launch the search.",
    opJobTitle: "Job title",
    opJobTitlePlaceholder: "e.g. Software Engineer",
    opLinkedJd: "Linked JD",
    opUsingJdTitle: "title used for the search",
    opSubtitle: "Find external opportunities for your candidates",
    opCandidate: "Candidate",
    opSelectCandidate: "Select a candidate",
    opCityRegion: "City/Region",
    opCountry: "Country",
    opLocation: "Location",
    opLaunchSearch: "Launch search",
    opSearching: "Searching...",
    opNoResult: "No opportunities found",
    opNoResultDesc: "Try adjusting the location or seniority level",
    opVectorScore: "Match score",
    opApplied: "Applied",
    opSaved: "Saved",
    opTargetCandidate: "Target Candidate",
    opDescription: "Description",
    opRecruiterFound: "Recruiter found",
    opViewLinkedIn: "View LinkedIn",
    opSearchingRecruiter: "Searching for recruiter...",
    opFindRecruiter: "Find recruiter on Google",
    opSaveForLater: "Save for later",
    opMarkApplied: "Mark as applied",
    opViewOnLinkedIn: "View on LinkedIn",
    hTitle: "History",
    hSubtitle: "All matched external jobs saved across your candidates",
    hAllJobs: "All jobs",
    hApplied: "Applied",
    hAppliedFilter: "Applied",
    hDescription: "Description",
    hFindRecruiter: "Find recruiter",
    hLoading: "Loading...",
    hMarkApplied: "Mark as applied",
    hMinScore: "Minimum score",
    hNoResult: "No results",
    hNoResultDesc: "Adjust your filters and try again",
    hRecruiterFound: "Recruiter found",
    hSaveForLater: "Save for later",
    hSaved: "Saved",
    hSavedFilter: "Saved",
    hSearchPlaceholder: "Search jobs...",
    hSearchingRecruiter: "Searching for recruiter...",
    hTargetCandidate: "Target Candidate",
    hVectorScore: "Match score",
    hViewLinkedIn: "View LinkedIn",
    hViewOnLinkedIn: "View on LinkedIn",
    hSortByDate: "Sort by date",
    hSortByScore: "Sort by score",
    gjsTitle: "Google Jobs Search",
    gjsSubtitle: "Import jobs from Google Jobs",
    gjsSearch: "Search",
    gjsSearching: "Searching...",
    gjsJobTitle: "Job title",
    gjsCompany: "Company",
    gjsLocation: "Location",
    gjsSalary: "Salary",
    gjsSummary: "Summary",
    gjsJobDescription: "Job description",
    gjsKeyResponsibilities: "Key responsibilities",
    gjsRequirements: "Profile sought",
    gjsQualifications: "Qualifications",
    gjsSoftSkills: "Soft skills",
    gjsFound: "found",
    gjsImport: "Import",
    gjsImporting: "Importing...",
    gjsImported: "Imported",
    gjsExhaustiveRunning: "Exhaustive search running",
    gjsStop: "Stop",
    gjsExhaustiveDone: "Exhaustive search complete",
    gjsEditTitle: "Edit before import",
    gjsSaveJD: "Create JD",
    gjsNoResult: "No results",
    gjsNoResultHint: "Try refining your search",
    gjsSearchError: "Search failed — please try again.",
    gjsAlreadyImported: "Already imported",
    gjsEmptyHint: "Search for jobs and import them to your JD",
    calendarLoading: "Loading…",
    calendarLoadingRdv: "Loading appointments…",
    calendarNoEvents: "No events this day",
    cpcMatchingSkills: "Matching skills",
    cpcMissingSkills: "Missing skills",
    cpcTechSkills: "Technical skills",
    cpcSoftSkills: "Soft skills",
    cpcDayOne: "Operational from day one",
    cpcTrainingNeeded: "Training needed",
    cpcExperience: "Work experience",
    cpcDomainRelevance: "Sector relevance",
    cpcInterviewPrep: "Interview prep",
    cpcPresent: "Present",
    cpcMore: "more…",
    cpcHighDemandSkills: "In-demand skills:",
    cpcEmergingSkills: "Emerging skills:",
    cpcMarketDev: "Market & development",
    cpcSuggestedCerts: "Suggested certifications:",
    ruTitle: "Unavailability",
    ruStart: "Start",
    ruEnd: "End",
    ruReason: "Reason (optional)",
    ruReasonPlaceholder: "Leave, appointment, etc.",
    ruAdd: "Add",
    ruAdding: "Adding…",
    ruEmpty: "No unavailability",
    ruErrAdd: "Add failed",
    ruBlockAdded: "Block added",
    ruErrDelete: "Delete failed",
    ruBlockDeleted: "Block deleted",
    smdCoordinates: "Coordinates",
    smdMessage: "Message",
    smdChannel: "Channel",
    smdAddPhone: "+ Add phone",
    smdAddEmail: "+ Add email",
    smdSelectTemplateOpt: "Select template",
    smdChooseTemplate: "Choose a template…",
    smdAiGenerateOpt: "AI generate",
    smdWriteFreelyOpt: "Write freely",
    smdComposePlaceholder: "Compose your message…",
    smdBasedOnCoords: "Based on available coordinates",
    smdSentToast: "✅ Message sent! Waiting for response…",
    calendarManageRdv: "Manage appointment",
    calendarReportPlaceholder: "Notes on the discussion, key points covered…",
    calendarNoEvent: "No events on this day",
    calendarTotalEvents: "{count} event(s) total",
    slotPhReason: "Reason (optional)",
    slotPhDurationOpt: "Duration (min, optional)",
    slotPhDuration: "Duration (min)",
    slotPhLocation: "Location",
    slotPhVideo: "Video link",
    slotPhNote: "Internal note",
    slotMsgEdited: "Hello {name}, the details of your interview for the {job} role have been updated.",
    slotMsgLocation: "📍 Location: {location}",
    slotMsgVideo: "🔗 Video link: {url}",
    slotMsgCancelled: "Hello {name}, your interview for the position {job} has unfortunately been cancelled. We will get back to you to reschedule. Thank you for your understanding.",
    slotMsgRescheduled: "Hello {name}, your interview for the position {job} has been rescheduled to {datetime}. Can you confirm your availability?",
    slotMsgRepropose: "Hello {name}, we need to reschedule your interview for the position {job}. Could you suggest some time slots that work for you?",
    slotManageTitle: "Manage Appointment",
    slotActionCancel: "Cancel",
    slotActionReschedule: "Reschedule",
    slotActionEdit: "Edit details",
    slotRescheduleDirect: "I set the date",
    slotRescheduleRepropose: "Candidate proposes",
    slotSendToCandidate: "Send to candidate",
    slotDontSend: "Do not send",
    slotNoPhone: "No WhatsApp number for this candidate — action recorded, message not sent.",
    anlTitle: "Analytics",
    anlSubtitle: "Platform-wide usage, engagement & performance (super-admin)",
    anlRefresh: "Refresh",
    anlPeriod: "Period",
    anlPreset_today: "Today",
    anlPreset_7d: "7 days",
    anlPreset_30d: "30 days",
    anlPreset_90d: "90 days",
    anlPreset_mtd: "Month",
    anlPreset_ytd: "Year",
    anlGranularity: "Granularity",
    anlGranAuto: "Auto",
    anlGranDay: "Day",
    anlGranWeek: "Week",
    anlGranMonth: "Month",
    anlAllEnterprises: "All companies",
    calendarScopeMine: "My company",
    calendarScopeMyCandidates: "My candidates",
    anlAllUsers: "All users",
    anlError: "Error",
    anlNoData: "No data for this period",
    anlKpiCandidates: "Candidates",
    anlKpiJds: "Job descriptions",
    anlKpiWaSent: "WhatsApp sent",
    anlKpiWaReceived: "WhatsApp received",
    anlKpiInterviews: "Interviews",
    anlKpiOutreach: "Outreach sent",
    anlKpiPsy: "Psychometric tests",
    anlKpiWebinars: "Webinars",
    anlKpiSearches: "JD searches",
    anlKpiAiCalls: "AI calls",
    anlKpiTokens: "Tokens",
    anlTokensHint: "prompt + completion",
    anlKpiAiCost: "AI cost",
    anlKpiEmailCost: "Email cost",
    anlTrendsTitle: "Trends over time",
    anlTrendsSub: "Volume per period",
    anlMetric: "Metric",
    anlMetric_candidates: "Candidates",
    anlMetric_jds: "Job descriptions",
    anlMetric_wa_sent: "WhatsApp sent",
    anlMetric_wa_received: "WhatsApp received",
    anlMetric_interviews: "Interviews",
    anlMetric_outreach: "Outreach",
    anlMetric_tokens: "Tokens",
    anlMetric_cost_usd: "AI cost",
    anlFunnelTitle: "Recruitment funnel",
    anlFunnelSub: "Cohort of candidates created in the period",
    anlStage_sourced: "Sourced",
    anlStage_contacted: "Contacted",
    anlStage_interested: "Interested",
    anlStage_interview: "Interview",
    anlStage_hired: "Hired",
    anlOfSourced: "of sourced",
    anlConv: "conv.",
    anlAiModelTitle: "AI cost by model",
    anlAiModelSub: "Estimated spend per model version",
    anlCalls: "calls",
    anlNoPrice: "no rate",
    anlLeaderTitle: "Recruiter leaderboard",
    anlLeaderSub: "Productivity per user",
    anlEntTitle: "Top companies",
    anlEntSub: "Activity & cost per company",
    anlAiFnTitle: "AI usage by function",
    anlAiFnSub: "Tokens & cost per calling function",
    anlMissingPricing: "Missing pricing for",
    anlColUser: "User",
    anlColEnterprise: "Company",
    anlColCandidates: "Candidates",
    anlColJds: "JDs",
    anlColWaSent: "WA sent",
    anlColReplyRate: "Reply rate",
    anlColInterviews: "Interviews",
    anlColConv: "Conv. rate",
    anlColTokens: "Tokens",
    anlColAiCost: "AI cost",
    anlColEmailCost: "Email cost",
    ipSemanticAnalyzing: "Semantic analysis in progress…",
    ipYourJob: "Your position",
    opExternalSearch: "External search",
    opSearchPrompt: "Start a search to see the offers available for",
    dbJdCountShort: "JD",
    dbPendingTitle: "Pending Candidate Responses",
    dbPendingEmpty: "No pending confirmations",
    dbPendingMovedReview: "moved to In Review",
    dbPendingRejected: "rejected",
    dbPendingFailProcess: "Failed to process confirmation",
    dbPendingFailSkip: "Failed to skip confirmation",
    navCalendar: "Calendar",
    epTemplateLabel: "WhatsApp template",
    epTemplateVarsHint: "The template variables will be automatically filled with the candidate's information.",
    themeDark: "Dark",
    themeLight: "Light",
    vivSubtitle: "Broad sourcing, no scoring, outside the pipeline.",
    vivFoundSuffix: "found…",
    vivProfilesSuffix: "profiles",
    vivAlreadyInPipeline: "already in pipeline",
    vivTitlePlaceholder: "Job title",
    vivCityPlaceholder: "City",
    vivCountryPlaceholder: "Country",
    vivRadius: "Radius",
    vivRadiusAria: "Search radius",
    vivRadiusNeedCity: "Enter a city to enable the radius",
    vivSimilarTitles: "Similar titles",
    vivOpenToWork: "Open to work",
    carteCandidats: "candidates located",
    carteHorsZone: "outside the map",
    carteSansLieu: "no known city",
    carteAucun: "No candidate located in this area",
    carteCentre: "search centre",
    carteSansCoord: "towns not placed",
    carteProximite: "Approximate boundaries: each area groups the places closest to one town. These are not administrative borders.",
    carteTitre: "Candidate distribution",
    carteRayon: "{km} km radius",
    carteAgrandir: "Expand",
    carteReduire: "Collapse",
    carteNCandidats: "{n} candidates",
    carteUnCandidat: "1 candidate",
    carteZonesTitre: "Areas",
    carteAutresZones: "+{n} more areas",
    carteDistance: "{km} km from the centre",
    carteLegendeTaille: "Size: number of candidates",
    carteLegendeRayon: "Search radius",
    carteLegendeHors: "Outside the radius",
    carteHorsRayon: "outside the radius",
    carteChargement: "Loading map…",
    carteInvite: "Choose a city to see where candidates are.",
    carteIndisponible: "Map unavailable for this location.",
    dispoOuvert: "Open to work",
    dispoPeutEtre: "Possibly available",
    dispoPeuProbable: "Unlikely to be available",
    dispoInconnu: "Availability unknown",
    vivOpenToWorkOnly: "Open only",
    vivOpenToWorkMaybe: "Open and maybe",
    vivOpenToWorkShortfall: "No further open profiles found for these criteria.",
    vivMaxPerEngine: "Max / engine",
    vivExperience: "Experience",
    vivMin: "min",
    vivMax: "max",
    vivMinYearsAria: "Minimum experience (years)",
    vivMaxYearsAria: "Maximum experience (years)",
    vivYears: "yrs",
    vivSearching: "Searching…",
    vivSearch: "Search",
    vivNoResultsTitle: "No profile found",
    vivNoResultsText: "Broaden the job title, drop the city, or turn on “Similar titles” to cast a wider net.",
    vivEmptyTitle: "Build your talent pool",
    vivEmptyText: "Enter a job title (and a location), then run the search: sourced profiles, no scoring, already deduplicated against your pipeline.",
    vivAdded: "Added",
    vivRetry: "Retry",
    vivAddBtn: "Pool",
    vivPageTitle: "Talent Pool",
    skillNotInCatalog: "Skill not found in the sourcing catalogue",
    langEvidenceSkillOnly: "Language listed as a skill only — to verify",
    skillLanguageDetected: "Detected as a language — verified against the profile's Languages, and kept as a skill",
    loginLoading: "Loading…",
    loginErrEmailPasswordRequired: "Email and password are required.",
    loginErrLoginFailed: "Login failed",
    loginErrEnterEmailFirst: "Enter your email address first.",
    loginErrResetSendFailed: "Could not send the reset email.",
    loginErrResetSendFailedCatch: "Could not send the reset email.",
    loginErrFirstNameEmailRequired: "First name and email are required.",
    loginErrProEmailRequired: "Please use a work email address (not Gmail, Yahoo, Outlook, etc.).",
    loginErrSelectEnterprise: "Select your company or choose “create a new one”.",
    loginErrEnterEnterpriseName: "Enter your company name.",
    loginErrEnterpriseAlreadyExists: "This company already exists — select it from the list instead of creating a duplicate.",
    loginErrSignupSubmitFailed: "Could not submit your request.",
    loginErrSignupSubmitFailedCatch: "Could not submit your request.",
    loginSignupTitle: "Create an account",
    loginSignupSentTitle: "Request sent",
    loginSignupSentBody: "Your request will be reviewed by an administrator. You will receive an email once it is approved.",
    loginBackToLogin: "Back to login",
    loginPhFirstName: "First name",
    loginPhLastName: "Last name",
    loginPhEmailSignup: "your@email.com",
    loginPhEnterprise: "Your company",
    loginPhEnterpriseName: "Your company name",
    loginNewEnterpriseCheckbox: "My company is not listed — create a new one",
    loginSubmitRequest: "Send request",
    loginBackToLoginArrow: "← Back to login",
    loginTitle: "Sign in to your account",
    loginResetSentTitle: "Password reset email sent!",
    loginResetSentBody: "Check your email inbox (or spam folder) for a reset link.",
    loginResetLinkExpiry: "The link expires in 24 hours.",
    loginBackToLoginEn: "Back to login",
    loginTryAnotherEmail: "Try another email",
    loginEmailLabel: "Email address",
    loginPhEmail: "your@email.com",
    loginPasswordLabel: "Password",
    loginSigningIn: "Signing in…",
    loginSignIn: "Sign in",
    loginForgotPassword: "Forgot password?",
    loginNoAccountSignup: "No account yet? Create one",
    deelWCountryFrance: "France",
    deelWCountryUk: "United Kingdom",
    deelWCountryUs: "United States",
    deelWCountryGermany: "Germany",
    deelWCountryBelgium: "Belgium",
    deelWCountrySpain: "Spain",
    deelWNotAuthenticated: "Not authenticated",
    deelWCreateError: "Creation error",
    deelWToastCreatedConfirmed: "Deel contract created and confirmed",
    deelWToastCreatedPending: "Deel contract created — confirmation pending",
    deelWLegalEntityLabel: "Legal entity",
    deelWLoading: "Loading…",
    deelWTeamLabel: "Team (client team)",
    deelWTitle: "Create Deel contract — {candidate.name}",
    deelWContractTypeLabel: "Contract type",
    deelWTypeIc: "Independent Contractor (IC)",
    deelWTypeEor: "EOR (Employee)",
    deelWNext: "Next",
    deelWCountryLabel: "Country",
    deelWCurrencyLabel: "Currency",
    deelWStartDateLabel: "Start date",
    deelWContractTitleLabel: "Contract title",
    deelWContractTitlePlaceholder: "e.g. Senior Full-Stack Engineer",
    deelWAmountLabel: "Amount",
    deelWScaleLabel: "Scale",
    deelWFrequencyLabel: "Frequency",
    deelWSeniorityLabel: "Seniority",
    deelWSelect: "Select…",
    deelWJobTitleLabel: "Job title",
    deelWScopeLabel: "Scope of work (template)",
    deelWNationalityLabel: "Nationality (employee)",
    deelWEmploymentTypeLabel: "Employment type",
    deelWHourlyRateLabel: "Hourly rate",
    deelWAnnualSalaryLabel: "Annual salary",
    deelWHoursPerWeekLabel: "Hours / week",
    deelWNoticeLabel: "Notice period",
    deelWSickLeaveLabel: "Sick leave days",
    deelWProbationLabel: "Probation period (days)",
    deelWStateLabel: "State / region (optional)",
    deelWStatePlaceholder: "e.g. CA (required for some countries)",
    deelWWorkVisaRequired: "Work visa required",
    deelWHourlyPay: "Hourly pay",
    deelWBenefitsLabel: "Benefits (optional)",
    deelWNone: "None",
    deelWContributionPlaceholder: "Contribution (%)",
    deelWBack: "Back",
    deelWCreate: "Create",
    deelWCreating: "Creating…",
    deelWClose: "Close",
    deelWCreatedConfirmed: "Contract created and confirmed",
    deelWCreated: "Contract created",
    deelWPendingConfirmation: "Confirmation pending — Deel is finalizing the contract, the status will update automatically.",
    admMsgTestMissingCreds: "Failed: enter the Account SID and Auth Token to run a test.",
    admMsgTestErrorPrefix: "Test error: ",
    admMsgTwilioOk: "Twilio connection OK ✓",
    admMsgTwilioAuthFailed: "Twilio authentication failed ✗ ",
    admMsgErrorPrefix: "Error: ",
    admMsgSaved: "Saved ✓",
    admMsgClearConfirm: "Clear the dedicated Twilio credentials? The company will fall back to the global configuration.",
    admMsgClearedGlobalActive: "Cleared — global configuration active",
    admMsgCalendlySaved: "Calendly link saved ✓",
    admMsgContentSidsSaved: "Content SIDs saved ✓",
    admMsgOwnAccountConfigured: "Dedicated Twilio account (BYO): configured (••••XXXX)",
    admMsgUsingGlobalConfig: "Using the global TrueCalling configuration.",
    admMsgAccountSidLabel: "Account SID",
    admMsgNeverDisplayed: "(never displayed)",
    admMsgOptional: "(optional)",
    admMsgWhatsappFromLabel: "WhatsApp number (From)",
    admMsgContentSidsTitle: "Template Content SIDs (per language)",
    admMsgContentSidsHelp: "Required to send a template from a dedicated account. The HX… must come from the Content Template Builder of THIS Twilio (sub)account.",
    admMsgSaveContentSidsBtn: "Save Content SIDs",
    admMsgCalendlyLabel: "Calendly link (variable {{5}} of the WhatsApp template)",
    admMsgCalendlyPlaceholder: "https://calendly.com/your-link",
    admMsgSaveBtn: "Save",
    admMsgTestConnectionBtn: "Test connection",
    admMsgClearBtn: "Clear",
    admMsgFooterTip: "Tip: click Test connection before saving — a “code 20003” failure means the Account SID / Auth Token are wrong. With no configuration here, the company sends through the global TrueCalling Twilio account.",
    admTeamSessionExpired: "Session expired — sign in again to send invitations.",
    admTeamCreateMemberFailed: "Could not create the member",
    admTeamAccountNotCreated: "Account not created (HTTP {status}) — try again via “Resend invitation”.",
    admTeamMemberAddedInvited: "Member added and invited — account created.",
    admTeamMemberAddedNoEmail: "Member added (no email → no account).",
    admTeamFailurePrefix: "Failed: ",
    admTeamInviteResent: "Invitation resent — account created.",
    admTeamResendFailedPrefix: "Resend failed: ",
    admTeamLoading: "Loading…",
    admTeamLeadAndCount: "Lead: {nom} · {n} member(s)",
    admTeamAddMemberBtn: "+ Member",
    admTeamStatusActive: "✓ Active",
    admTeamStatusPending: "Pending",
    admTeamResendBtn: "Resend",
    admTeamStatusNoAccount: "No account",
    admTeamRemoveBtn: "Remove",
    admTeamFullNamePlaceholder: "Full name *",
    admTeamEmailPlaceholder: "Email (optional)",
    admTeamRoleMemberOption: "TeamMember",
    admTeamRoleLeaderOption: "TeamLeader",
    admTeamAddBtn: "Add",
    admTeamCancelMemberBtn: "Cancel",
    admTeamCountExpandHint: "{n} member(s) — click to expand",
    admTeamNamePlaceholder: "Team name",
    admTeamCreateBtn: "Create",
    admTeamCancelTeamBtn: "Cancel",
    admTeamCreateTeamBtn: "+ Create a team",
    admUsersSessionExpired: "Session expired — sign in again to send invitations.",
    admUsersMemberCreateFailed: "Could not create the member",
    admUsersAccountNotCreated: "Account not created (HTTP {status}) — try again via “Resend invitation”.",
    admUsersInviteSent: "Invitation sent — account created.",
    admUsersInviteFailed: "Invitation failed: ",
    admUsersInviteResent: "Invitation resent — account created.",
    admUsersResendFailed: "Resend failed: ",
    admUsersLoading: "Loading…",
    admUsersSearchPlaceholder: "Search name / email…",
    admUsersFilterAll: "All",
    admUsersFilterActive: "Active",
    admUsersFilterPending: "Pending",
    admUsersInviteCta: "+ Invite",
    admUsersEmailPlaceholder: "Email *",
    admUsersFullNamePlaceholder: "Full name",
    admUsersTeamOption: "Team *",
    admUsersSending: "Sending…",
    admUsersInviteSubmit: "Invite",
    admUsersCancel: "Cancel",
    admUsersColName: "Name",
    admUsersColEmail: "Email",
    admUsersColTeam: "Team",
    admUsersColRole: "Role",
    admUsersColStatus: "Status",
    admUsersColActions: "Actions",
    admUsersBadgeActive: "Active",
    admUsersBadgePending: "Pending",
    admUsersBadgeNoAccount: "No account",
    admUsersRowInvite: "Invite",
    admUsersRowRemove: "Remove",
    admUsersEmpty: "No users",
    jobAlertAxisTitle: "Title",
    jobAlertAxisSkills: "Skills",
    jobAlertAxisLocation: "Location",
    jobAlertAxisSalary: "Salary",
    jobAlertAxisIndustry: "Industry",
    jobAlertToday: "today",
    jobAlertYesterday: "yesterday",
    jobAlertDaysAgo: "{days} d ago",
    jobAlertMonthsAgo: "{months} months ago",
    jobAlertPanelTitle: "External job monitoring",
    jobAlertNewCount: "{fresh} new",
    jobAlertLastCheck: "last check {relative}",
    jobAlertPause: "Pause",
    jobAlertEnable: "Enable monitoring",
    jobAlertDescActive: "New job postings matching {candidateName}'s profile are checked automatically. Only those above the compatibility threshold trigger an alert.",
    jobAlertDescInactive: "No monitoring is active for {candidateName}. Enabling it starts a periodic check of external job postings matching their profile.",
    jobAlertScopeTitle: "Monitored scope",
    jobAlertScopeHelp: "Only the companies listed here are monitored. Add domains (acme.com) or company LinkedIn URLs, separated by commas.",
    jobAlertScopeInputLabel: "Companies to monitor",
    jobAlertAddBtn: "Add",
    jobAlertScopeAdded: "{n} company(ies) added to the scope.",
    jobAlertScopeAddedHint: "Their postings will appear at the next check.",
    jobAlertLoading: "Loading alerts…",
    jobAlertEmpty: "No matching job postings yet. You will be notified as soon as one passes the threshold.",
    jobAlertPublished: " · published {relative}",
    jobAlertScoreDetail: "Score breakdown",
    jobAlertView: "View",
    jobAlertMarkRead: "Mark as read",
    jobAlertDismiss: "Dismiss this job posting",
    deelAnDaysSuffix: "{n} d",
    deelAnFunnelSent: "Sent",
    deelAnFunnelWorkerSigned: "Signed (worker)",
    deelAnFunnelClientSigned: "Signed (client)",
    deelAnFunnelExecuted: "Contract executed",
    deelAnFunnelActive: "Active",
    deelAnAgingSubPrefix: "{n} d in ",
    deelAnStatusDraftWord: "draft",
    deelAnStatusPendingWord: "pending signature",
    deelAnPageTitle: "Deel — Traceability",
    deelAnSubtitle: "Contract lifecycle, signatures and onboarding",
    deelAnEmptyCardTitle: "No Deel contract",
    deelAnEmptyBody: "No Deel contract for this company. Contracts created from the pipeline will appear here with their full lifecycle.",
    deelAnKpiTrackedContracts: "Tracked contracts",
    deelAnKpiTotalHint: "total",
    deelAnKpiMedianSignDelay: "Median time to signature",
    deelAnHintSignedCountMedian: "{n} signed",
    deelAnKpiAvgSignDelay: "Average time to signature",
    deelAnHintSignedCountAvg: "{n} signed",
    deelAnKpiAvgExecDelay: "Average time to execution",
    deelAnHintExecutedCount: "{n} executed",
    deelAnKpiStuckContracts: "Stalled contracts",
    deelAnHintNoSignatureAfterDays: "> {n} d without signature",
    deelAnFunnelCardTitle: "Signature funnel",
    deelAnFunnelCardSubtitle: "Derived from transition timestamps",
    deelAnFunnelOfContracts: "of contracts",
    deelAnFunnelConvAbbr: "conv.",
    deelAnKycCardTitle: "KYC / onboarding status",
    deelAnKycEmpty: "No KYC data",
    deelAnStuckCardTitle: "Stalled contracts",
    deelAnStuckCardSubtitle: "Draft or pending signature for more than {n} days",
    deelAnDaysShort: "{n} d",
    deelAnStuckEmpty: "No stalled contracts 🎉",
    admProfilNameRequired: "The name is required",
    admProfilSaveError: "Error",
    admProfilProEmailError: "Please use a work email address (not Gmail, Yahoo, Outlook, etc.).",
    admProfilCompanyNameLabel: "Company name *",
    admProfilUrlLabel: "URL",
    admProfilLogoLabel: "Logo (URL)",
    admProfilAboutLabel: "About",
    admProfilFranchise: "Franchise",
    admProfilTraining: "Training",
    admProfilSaving: "Saving…",
    admProfilSaved: "✓ Saved",
    admProfilSave: "Save",
    admProfilClientAdminSection: "Client admin",
    admProfilEmailLabel: "Email",
    admProfilSending: "Sending…",
    admProfilReinvite: "Re-invite",
    admProfilInvite: "Invite",
    admProfilConfirmed: "✓ Confirmed",
    admProfilPending: "⚠ Pending",
    admProfilAccountActive: "✓ Account active — access updated, password unchanged.",
    admProfilInviteSent: "✓ Invitation sent",
    admProfilEmailRecap: "Email:",
    admProfilTempPassword: "Temporary password:",
    admProfilInviteError: "Invitation error. Please try again.",
    fsLanguagesDetected: "Languages detected",
    aqHideChips: "Hide tags",
    aqShowChips: "Show tags",
    aqChipsCount: "{n} selected",
    planLimitQuotaTitle: "You have reached your plan's limit",
    planLimitQuotaBody: "You have used everything your plan allows for this cycle. A higher plan raises the limit immediately.",
    planLimitFeatureTitle: "Not included in your plan",
    planLimitFeatureBody: "This feature belongs to the higher plans. The change takes effect right away.",
    planLimitJdCapTitle: "Too many active job posts",
    planLimitJdCapBody: "Your plan caps how many job posts can be active at once. Deactivate one, or move to a higher plan to keep them all open.",
    planLimitJdCycleTitle: "No job posts left this cycle",
    planLimitJdCycleBody: "You have created every job post your plan allows this cycle. A deleted post still counts, and changing a post's title or location counts as a new post.",
    planLimitUnpaidTitle: "Payment required",
    planLimitUnpaidBody: "Your account stays read-only until the payment goes through.",
    planLimitSeePlans: "See plans",
    planLimitSettleCta: "Pay now",
    planLimitLater: "Later",
    convSendFailed: "Sending failed. Your message was kept — try again.",
    jdSourcingBadge: "Sourcing",
    jdSourcingBadgeHint: "Created automatically from a search: running it again reapplies exactly the same criteria.",
    aqCityOrRegion: "City or region",
    aqRegionRecognized: "Region recognised: {name} ({n} towns). Only profiles located in the region are kept; the radius does not apply.",
    fuStatusPending: "Pending",
    fuStatusNew: "New",
    cvFilterApplied: "Applications",
    jdTabWhatsapp: "Template",
    jdWaTitle: "First-contact WhatsApp message",
    jdWaModeGeneric: "Company default template",
    jdWaModeCustom: "Template dedicated to this job",
    jdWaEffectGeneric: "Candidates for this job receive the default template.",
    jdWaEffectCustomApproved: "Candidates for this job receive this template in this language.",
    jdWaEffectCustomPending: "Until a template is approved in the message language, the default template is sent.",
    jdWaLanguage: "Language",
    jdWaRefresh: "Refresh status",
    jdWaRejectedReason: "Reason:",
    jdWaReviewDelay: "WhatsApp review takes from a few minutes to 24 hours. The status updates automatically.",
    jdWaEditorLabel: "Message text",
    jdWaEditorPlaceholder: "Hello, a position might interest you…",
    jdWaInsertVar: "Insert:",
    jdWaRulesOk: "WhatsApp rules met.",
    jdWaPreview: "Preview",
    jdWaNewVersionHint: "A submitted template cannot be edited: your changes will create a new version.",
    jdWaSaveDraft: "Save draft",
    jdWaSubmit: "Submit to WhatsApp",
    jdWaSubmittedOk: "Template submitted to WhatsApp.",
    jdWaDraftSaved: "Draft saved.",
    jdWaQuota: "Submission limit reached for today.",
    jdWaErrorGeneric: "The operation failed. Please try again.",
    jdWaHistory: "Versions",
    jdWaSampleFirstName: "John",
    jdWaVar_candidate_first_name: "Candidate first name",
    jdWaVar_job_title: "Job title",
    jdWaVar_company_name: "Company",
    jdWaVar_job_city: "City",
    jdWaVar_apply_link: "Application link",
    jdWaStatus_draft: "Draft",
    jdWaStatus_pending: "Under WhatsApp review",
    jdWaStatus_approved: "Approved — ready to use",
    jdWaStatus_rejected: "Rejected by WhatsApp",
    jdWaStatus_paused: "Paused by WhatsApp",
    jdWaStatus_disabled: "Disabled by WhatsApp",
    jdWaStatus_error: "Error",
    jdWaErr_body_empty: "The message is empty.",
    jdWaErr_body_too_long: "The message exceeds 1024 characters.",
    jdWaErr_starts_with_variable: "The message cannot start with a variable.",
    jdWaErr_ends_with_variable: "The message cannot end with a variable.",
    jdWaErr_adjacent_variables: "Two variables cannot be next to each other: add text between them.",
    jdWaErr_variables_not_sequential: "Variables must be numbered in order.",
    jdWaErr_unknown_variable: "Variable not allowed.",
    jdWaErr_missing_sample: "A variable has no sample value.",
    jdWaErr_unmapped_variable: "A variable in the text is not recognised.",
    jdWaErr_too_many_variables: "Too many variables for the text length: add more text.",
    jdWaErr_shortened_url: "Shortened links are rejected by WhatsApp.",
    jdWaErr_unsupported_language: "Language not supported.",
    jdWaChip_approved: "WhatsApp ✓",
    jdWaChip_pending: "WhatsApp in review",
    jdWaChip_attention: "WhatsApp needs attention",
    jdWaChip_rejected: "WhatsApp rejected",
    jdWaChip_none: "WhatsApp to write",
    jdWaFail_content: "WhatsApp refused the text at creation. Edit it and submit again.",
    jdWaFail_approval: "The submission to WhatsApp was refused. Try again or edit the text.",
    jdWaFail_account: "The company’s WhatsApp account changed: submit the template again.",
    jdWaNormsTitle: "Rules to follow before submitting",
    jdWaNormsGdprTitle: "GDPR",
    jdWaNormsGdpr: "Introduce your company and the job: the person must know who is contacting them and why.\nAlways offer a way to opt out, e.g. “Reply STOP to stop receiving messages”.\nUse only the first name, job title, company, city and job link.\nDo not write or ask for any sensitive data (health, origin, religion, opinions, family situation…).\nStay factual: no promise of hiring and no pressure to reply.",
    jdWaNormsMetaTitle: "WhatsApp (Meta) approval",
    jdWaNormsMeta: "Every template is reviewed by WhatsApp before it can be used: from a few minutes to 24 hours.\nNo variable at the very start or end of the message, and no two variables in a row.\nKeep enough text around variables; a realistic sample is provided for each one.\nNo shortened links (bit.ly…), no excessive capitals and no misleading content.\nA rejected template can be fixed and submitted again: a new version is created.",
    jdWaWarnNoStop: "Add a way to opt out, e.g. “Reply STOP to stop receiving messages”.",
    jdWaEffectPreviousApproved: "Approved version v{v} keeps being sent until the new one is approved.",
    jdWaNotInPlan: "Job-specific templates are not included in your plan. This job still uses one: you can switch back to the generic template.",
    "billing.awaitingDifference": "payment of the difference pending",
    "billing.cta.changePlan": "Switch to this plan",
    "billing.cta.portal": "Manage my subscription",
    "billing.cta.settle": "Pay my usage",
    "billing.currentPlan": "Current plan:",
    "billing.error.currencyMismatchFmt": "Your subscription is billed in {currency}: choose a billing region in that currency. To change currency, contact us.",
    "billing.error.featureNotInPlan": "This option is not available on your plan: upgrade to a higher plan.",
    "billing.error.generic": "Payment unavailable right now. Please try again in a moment.",
    "billing.error.noSubscription": "No Stripe subscription is linked to this account.",
    "billing.error.notAuthorized": "Only the account owner can change the subscription or make a payment.",
    "billing.error.notConfigured": "Online payment is temporarily unavailable.",
    "billing.error.otherCurrency": "another currency",
    "billing.error.planChangeFailed": "Stripe could not apply the change. Check your payment method under “{portal}”, then try again.",
    "billing.error.priceNotFound": "This plan is not yet available for online payment.",
    "billing.field.period": "Billing cycle",
    "billing.field.plan": "Plan",
    "billing.field.region": "Billing region",
    "billing.field.seats": "Users",
    "billing.interval.month": "month",
    "billing.interval.year": "year",
    "billing.opening": "Opening…",
    "billing.period.annual": "Annual (−20%)",
    "billing.period.monthly": "Monthly",
    "billing.redirecting": "Redirecting…",
    "billing.region.AFRICA": "Africa",
    "billing.region.APAC_PREMIUM": "APAC (premium)",
    "billing.region.APAC_VOLUME": "APAC (volume)",
    "billing.region.EU": "Europe",
    "billing.region.US": "United States",
    "billing.return.canceled": "Payment canceled: nothing was charged.",
    "billing.return.paymentConfirmed": "Payment confirmed.",
    "billing.return.pendingBank": "Your bank is still validating the payment: it will be applied as soon as it is confirmed. Then try the action again.",
    "billing.return.planActiveFmt": "Payment confirmed: {plan} plan active.",
    "billing.return.receivedLater": "Payment received: it will be applied automatically.",
    "billing.return.settled": "Settlement confirmed.",
    "billing.status.canceled": "canceled",
    "billing.status.incomplete": "incomplete",
    "billing.status.incomplete_expired": "expired",
    "billing.status.past_due": "payment overdue",
    "billing.status.paused": "paused",
    "billing.status.trialing": "in trial",
    "billing.status.unpaid": "unpaid",
    "billing.subscriptionStatusFmt": "subscription {status}",
    "billing.tabTitle": "Plan & billing",
    "billing.toast.alreadyOnPlan": "You are already on this plan with this number of users.",
    "billing.toast.chosenPlan": "the chosen plan",
    "billing.toast.nothingToSettle": "No usage to pay for.",
    "billing.toast.ownerOnly": "Only the account owner can change the subscription.",
    "billing.toast.requiresPayment": "Confirm payment of the difference in the Stripe window: your plan will switch automatically.",
    "billing.toast.scheduleCanceled": "Scheduled change canceled: you keep your current plan.",
    "billing.toast.scheduledPeriodEndFmt": "Change scheduled: you keep your current plan until the end of the paid period, then switch to {plan}. No refund.",
    "billing.toast.scheduledUntilFmt": "Change scheduled: you keep your current plan until {date}, then switch to {plan}. No refund.",
    "billing.toast.syncConfirmed": "Payment confirmed: plan updated.",
    "billing.toast.updated": "Plan updated. Only the prorated difference was charged.",
    "billing.toast.updatedFmt": "Plan updated to {plan}. Only the prorated difference was charged.",
    featureGateBack: "Back to dashboard",
    featureGateBody: "This page belongs to a higher plan. Move to a plan that includes it to open it; your other features stay available.",
    featureGateTitle: "Not included in your plan",
    planLimitJdNoneBody: "Your company's account does not allow creating job posts at the moment (limit set to 0). Contact TrueCalling support to enable it, or see the plans.",
    planLimitJdNoneTitle: "Job posts are not enabled yet",
    "planMeta.annualFmt": "€{n}/user/month billed annually (−20%)",
    "planMeta.core.desc": "Recruiting teams, from 1 seat: pooled credits (500 enrichments and 250 actions per seat per month), dedicated WhatsApp sender, multi-team, Deel, placement & outplacement, shared CSM.",
    "planMeta.core.label": "Business",
    "planMeta.enterprise.desc": "Large organizations, annual contract, 10+ seats: custom volumes, own Twilio account, MCP (beta), custom workflows, dedicated CSM, SLA and signed DPA.",
    "planMeta.enterprise.label": "Enterprise",
    "planMeta.freePrice": "€0",
    "planMeta.freemium.desc": "Discovery, 30 days per company: 1 job post, top 20 candidates ranked by AI, 5 enrichments and 10 outreach actions (email) per month. 1 seat.",
    "planMeta.freemium.label": "Free",
    "planMeta.legacyDesc": "Value from the old 3-tier model. Access is treated as “Free” until a current plan is selected and saved.",
    "planMeta.legacyLabelFmt": "{name} (legacy)",
    "planMeta.legacyPrice": "Legacy plan — choose a price",
    "planMeta.lite.desc": "Solo recruiter: unlimited AI search, 3 job posts, 50 enrichments and 50 emails per month, EMILY in draft mode, TrueFit 360 pay-per-use. 1 seat.",
    "planMeta.lite.label": "Lite",
    "planMeta.onQuote": "Custom quote",
    "planMeta.priceFmt": "€{n}/user/month",
    "planMeta.starter.desc": "Active recruiters, teams of up to 5 seats: unlimited job posts, email + WhatsApp, 300 enrichments and 150 actions per seat per month, analytics, 5 TrueFit tests included.",
    "planMeta.starter.label": "Professional",
    "planMeta.startupNote": "A startup? Ask us about our Startup Program during your demo.",
    "planMeta.trialNote": "Try TrueCalling free for 30 days. No credit card required.",
    signupCancelled: "Payment cancelled: nothing was charged. Your plan is still selected.",
    signupDidYouMean: "Did you mean {email}?",
    signupEnterpriseBody: "The Enterprise plan is priced on quote (annual contract, 10 users or more). Contact us and we will prepare your offer.",
    signupEnterpriseCta: "Contact us",
    signupErrCheckout: "Payment could not be started. Please try again in a moment.",
    signupErrEmailInvalid: "This email address is not valid.",
    signupErrEmailMismatch: "The two email addresses do not match.",
    signupErrEnterpriseExists: "A company with this name already has a TrueCalling space. Ask to join it, or enter your company’s exact name.",
    signupErrGeneric: "Something went wrong. Please try again.",
    signupErrRequired: "Please fill in your first name, last name, email and company name.",
    signupErrUndeliverable: "This address cannot receive email: the domain “{domain}” does not exist or accepts no mail. Please check for a typo.",
    signupExistingBody: "This address already has a TrueCalling space: we sent an access link to {email}. Also check your spam or junk folder.",
    signupHaveAccount: "Already have an account? Sign in",
    signupJoinExisting: "Your company already uses TrueCalling? Ask to join its space",
    signupNoPasswordNote: "No password to choose now: we email you a link to create it.",
    signupPeriodAnnual: "Annual (−20%)",
    signupPeriodMonthly: "Monthly",
    signupPhEmailConfirm: "Confirm your email",
    signupPlanLabel: "Your plan",
    signupRedirecting: "Opening secure payment…",
    "signupRegion.AFRICA": "Africa (USD)",
    "signupRegion.APAC_PREMIUM": "Asia-Pacific — premium markets (USD)",
    "signupRegion.APAC_VOLUME": "Asia-Pacific — volume markets (USD)",
    "signupRegion.EU": "European Union (EUR)",
    "signupRegion.US": "United States (USD)",
    signupRegionLabel: "Billing region",
    signupSeatsLabel: "Number of users",
    signupSeatsMax: "Up to {n} users on this plan.",
    signupSentBody: "We sent an email to {email} with a link to create your password. Also check your spam or junk folder; it can take a few minutes.",
    signupSentTitle: "Check your inbox",
    signupSubmitFree: "Create my free account",
    signupSubmitPaid: "Continue to secure payment",
    signupThanksBody: "Your space is being created. Within a few minutes you will receive an email with a link to create your password and sign in. Also check your spam or junk folder.",
    signupThanksEmail: "Email sent to: {email}",
    signupThanksHelp: "Nothing after 15 minutes? Write to us at {contact}.",
    signupThanksTitle: "Payment received — thank you!",
    signupUseSuggestion: "Use this address",
    signupWrongAddress: "Wrong address? Start again",
    trialExpiredBody: "Your company's 30-day trial is over. Your job descriptions, candidates and conversations are kept safe.",
    trialExpiredChoosePlan: "Choose a plan to keep using TrueCalling.",
    trialExpiredLogout: "Sign out",
    trialExpiredTitle: "Your free trial has ended",
    upsellPhoneBody: "One-click calling, texting and WhatsApp are included from the Lite plan. Switch plans to unlock them — the change takes effect immediately.",
    upsellWhatsappBody: "Sending WhatsApp messages is included from the Professional plan. Switch plans to unlock it — the change takes effect immediately.",
  },
};

export default locale;
export type LocaleData = typeof locale;
